{
  "404": {
    "title": "A página que procura não foi encontrada... 👀",
    "subtitle": "Por favor verifique se o link que está a tentar aceder está correto."
  },
  "LANDING": {
    "nav": {
      "calendar": "Agenda",
      "bookingPage": "Página de marcações",
      "pricing": "Planos"
    },
    "landing": {
      "metaTitle": "Agenda de marcações online",
      "pageTitle": "A única ferramenta que precisas para gerir o teu negócio",
      "pageDescription": "Recebe agendamentos 24/7 e reduz faltas com lembretes SMS automáticos. Fácil de configurar!",
      "tagline": "Agenda de marcações online nº 1 em Portugal 🇵🇹",
      "taglineBarbers": "Agenda de marcações online nº1 em Portugal para Barbeiros",
      "taglineSalon": "Agenda de marcações online nº1 em Portugal para Cabeleireiros",
      "taglineNails": "Agenda de marcações online simples e flexível para Nails Artists",
      "taglineMakeup": "Agenda de marcações online nº1 em Portugal para Makeup Artists",
      "taglineSpa": "Agenda de marcações online nº1 em Portugal para Spa's",
      "taglineGym": "Agenda de marcações online simples e flexível para o seu Estúdio ou Ginásio",
      "taglinePts": "Agenda de marcações online simples e flexível para Personal Trainers",
      "taglinePhysio": "Agenda de marcações online nº1 em Portugal para Fisioterapeutas",
      "taglinePsy": "Agenda de marcações online nº1 em Portugal para Psicólogos",
      "taglineNutri": "Agenda de marcações online nº1 em Portugal para Nutricionistas",
      "taglineDentist": "Agenda de marcações online nº1 em Portugal para Clínicas Dentárias",
      "taglinePharma": "Agenda de marcações online nº1 em Portugal para Farmácias",
      "taglineTherapy": "Agenda de marcações online nº1 em Portugal para Centros de Terapias",
      "taglineOsteo": "Agenda de marcações online nº1 em Portugal para Osteopatas",
      "taglineHomeo": "Agenda de marcações online nº1 em Portugal para Homeopatas",
      "taglineReiki": "Agenda de marcações online nº1 em Portugal para Mestres de Reiki",
      "taglineAcu": "Agenda de marcações online nº1 em Portugal para Acupuntura",
      "featuresPanel8": {
        "text": "Ver mais"
      },
      "stats": {
        "title1": "+20 milhões",
        "text1": "marcações processadas",
        "title2": "+3 milhões",
        "text2": "clientes marcaram",
        "title3": "+4.000",
        "text3": "negócios em Portugal",
        "title4": "+12.000",
        "text4": "profissionais usam"
      },
      "how-to": {
        "pill1": "CONTROLO TOTAL",
        "title1": "A tua agenda sempre contigo",
        "text1": "Acede à tua agenda a qualquer hora no telemóvel. Gerir o teu negócio nunca foi tão simples!",
        "pill2": "OPCIONAL",
        "title2": "O fim das chamadas perdidas",
        "text2": "Personaliza a tua página de marcações e partilha com os teus clientes, eles vão adorar!"
      },
      "noCreditCardNeeded": "Não necessita de cartão de crédito.",
      "terms": "Termos e condições",
      "privacy": "Política de privacidade",
      "cookies": "Política de cookies",
      "cookiesCta": "Ver política de cookies",
      "help": "Tens perguntas?",
      "faqs": "Perguntas Frequentes",
      "login": "Entrar",
      "promoCopy": "3 meses do Plano Pro pelo preço de 1",
      "heroPromoBadge": "3 meses Pro pelo preço de 1",
      "cancelAnytime": "Cancela quando quiseres",
      "noCreditCard": "Não é necessário inserir cartão de crédito",
      "googleRating": {
        "score": "4.9",
        "reviews": "+450 avaliações"
      },
      "registerCta": "Experimenta Grátis",
      "registerCta2": "Registar",
      "signupCtaAd": "Aproveitar promo",
      "contactCta": "Fala connosco",
      "headerDescription": "Recebe marcações 24/7 através da tua página de marcações personalizada, envia lembretes SMS automáticos aos teus clientes e reduz as faltas de comparência.",
      "featuresTitle": "Tudo que precisas para gerir<br/>e fazer crescer o teu negócio!",
      "featuresTitleBarber": "Tudo que precisas para gerir<br/>e fazer crescer a tua barbearia!",
      "featuresTitleSalon": "Tudo que precisas para gerir<br/>e fazer crescer o teu cabeleireiro!",
      "featuresTitleNails": "Tudo que precisas para gerir<br/>e fazer crescer o teu negócio de beleza!",
      "featuresTitleMakeup": "Tudo que precisas para gerir<br/>e fazer crescer o teu negócio de beleza!",
      "featuresTitleSpa": "Tudo que precisas para gerir<br/>e fazer crescer o teu negócio de beleza!",
      "featuresTitleGym": "Tudo o que precisas para gerir os teus treinos!",
      "featuresTitlePts": "Tudo o que precisas para gerir os teus treinos!",
      "featuresTitlePhysio": "Tudo que precisas para gerir <br/>a tua Clínica de Fisioterapia!",
      "featuresTitlePsy": "Tudo que precisas para gerir as tuas consultas!",
      "featuresTitleNutri": "Tudo que precisas para gerir as tuas consultas!",
      "featuresTitleDentist": "Tudo que precisas para gerir a tua Clínica Dentária!",
      "featuresTitlePharma": "Tudo que precisas para gerir marcações na tua Farmácia!",
      "featuresTitleTherapy": "Tudo que precisas para gerir e <br/>fazer crescer o teu Centro de Terapias!",
      "featuresTitleOsteo": "Tudo que precisas para gerir e <br/>fazer crescer a tua Clínica de Osteopatia!",
      "featuresTitleHomeo": "Tudo que precisas para gerir as tuas consultas <br/>de Homeopatia e Medicina Natural!",
      "featuresTitleReiki": "Tudo que precisas para gerir as tuas consultas de Reiki!",
      "featuresTitleAcu": "Tudo que precisas para gerir as tuas clínicas <br/>de Acupuntura e Medicina Tradicional Chinesa!",
      "footerLinksPrefix": "Marcações online para",
      "features": {
        "calendarTitle": "Agenda Online",
        "calendarText": "Acede à tua agenda de marcações a qualquer hora e em qualquer lugar no teu smartphone e recebe notificações de novas marcações em tempo real.",
        "bookingTitle": "Página de Marcações",
        "bookingText": "O teu logotipo, as tuas cores, a tua imagem. Personaliza a página de marcações à imagem do teu negócio.",
        "teamTitle": "Gestão de Equipa",
        "teamText": "Faz uma melhor gestão dos horários da tua equipa e distribui as marcações consoante a preferência dos teus clientes.",
        "smsTitle": "Lembretes SMS",
        "smsText": "Poupa tempo com o envio automático de lembretes SMS e E-mail na véspera das marcações.",
        "statsTitle": "Estatísticas",
        "statsText": "Optimiza o teu negócio acedendo a estatísticas e fichas de cliente. Conhece melhor os teus clientes e as suas preferências.",
        "bookingsTitle": "Marcações 24/7",
        "bookingsText": "Recebe marcações na tua agenda online a qualquer hora e em qualquer lugar com actualizações e notificações em tempo real.",
        "marketing2Title": "Marketing integrado",
        "marketing2Text": "Envia promoções segmentadas aos teus clientes com campanhas de SMS e E-mail e fideliza os teus clientes.",
        "mbway2Title": "Pagamento MBWay",
        "mbway2Text": "Fácil & seguro! Pagamentos online no momento da marcação através de MBWay, multibanco, cartão de crédito, Google Pay e Apple Pay.",
        "google2Title": "Google Reviews Boost",
        "google2Text": "Destaca o teu negócio no Google. Depois de cada marcação os teus clientes recebem um e-mail para classificarem o teu negócio no Google.",
        "loyaltyTitle": "Programa de Fidelização",
        "loyaltyText": "Cria um programa de fidelização com prémios para incentivar o regresso dos teus melhores clientes.",
        "crmTitle": "CRM Personalizado",
        "crmText": "Adiciona campos personalizados à página de marcações para recolher informações importantes e melhorar o atendimento.",
        "pixelTitle": "Conversões Google & Meta",
        "pixelText": "Analisa o impacto das tuas campanhas com os pixels de Google e Meta integrados."
      },
      "testimoniesTitle": "O que os nossos clientes dizem ❤️",
      "testemonies": {
        "testemonyBento": "A utilização do BUK, permite ao cliente agendar com toda a comodidade os serviços que pretende. Isso facilita em muito o nosso trabalho.",
        "testemonyAnton": "O BUK é fácil de usar, super interativo, prático e funcional, permite trabalhar de uma forma mais organizada e profissional.",
        "testemonyLigia": "Aderir ao BUK foi das melhores decisões que tomei a nível profissional, poupo horas de trabalho por semana e as minhas clientes adoram o facto de serem autónomas nas marcações.",
        "testemonyPraga": "A Buk é a plataforma que mais me auxiliou no trabalho até hoje. Simples, intuitiva e ainda bastante personalizável para cada negócio. Super recomendo! Para os clientes? Muito fácil de usar."
      },
      "businessesTitle": "Escolhe o teu negócio <br/>e regista-te gratuitamente!",
      "everyBusiness": "Uma agenda para todos os negócios.",
      "blog": "O nosso blog",
      "reachOut": "Fala connosco em",
      "businesses": {
        "barber": "Barbearias",
        "barbers": "Barbeiros",
        "salon": "Cabeleireiro",
        "salons": "Cabeleireiros",
        "nails": "Nail artist",
        "nailss": "Nail Artists",
        "makeup": "Makeup artist",
        "makeups": "Makeup artists",
        "fitness": "Fitness",
        "fisio": "Fisioterapeutas",
        "osteo": "Osteopatas",
        "dentist": "Dentista",
        "dentists": "Clínicas Dentárias",
        "psy": "Psicólogo",
        "psys": "Psicólogos",
        "beauty": "Beleza",
        "sports": "Desporto",
        "gyms": "Estúdios e Ginásios",
        "pts": "Personal trainers",
        "health": "Saúde",
        "pharma": "Farmácia",
        "pharmacies": "Farmácias",
        "therapy": "Centros de terapia",
        "alternativeTherapies": "Terapias alternativas",
        "osteopathy": "Osteopatia",
        "homeopathy": "Homeopatia",
        "reiki": "Reiki",
        "acupuncture": "Acupuntura",
        "nutri": "Nutricionistas",
        "nutricionists": "Nutricionistas",
        "others": "Outros"
      },
      "ctaSection": {
        "title": "Junta-te a mais de 4000 negócios em Portugal",
        "text": "Recebe marcações 24/7 através da tua página de marcações personalizada. Envia lembretes SMS automáticos aos seus clientes e reduz as faltas de comparência."
      },
      "footerText1": "BUK © uma marca de",
      "footerText2": "desenvolvido em Portugal 🇵🇹",
      "refText1": "convidou-te para o BUK",
      "refText2": "Tens 50% de desconto em planos profissionais.",
      "refText3": "Com este convite de"
    },
    "landCalendar": {
      "hero": {
        "title": "A tua agenda sempre contigo",
        "desc": "Acede à tua agenda a qualquer hora e em qualquer lugar. Gerir o teu negócio nunca foi tão simples!"
      },
      "feat1": {
        "title": "Configura a tua agenda à realidade do seu negócio",
        "check1": "Configura o teu horário de atendimento, bloqueia folgas e horas de almoço",
        "check2": "Opção de vista diária ou semanal",
        "check3": "Configura com que antecedência desejas permitir marcações (feitas pelos seus clientes)",
        "check4": "Oculta a vista de colaboradores em dias de folga"
      },
      "feat2": {
        "title": "Lembretes SMS / E-mail ilimitados e personalizáveis",
        "check1": "Dá um toque pessoal às comunicações efectuadas com os teus clientes",
        "check2": "Escreve o teu próprio SMS e escolhe o nome do remetente",
        "check3": "Adiciona informações importantes nos E-mails de marcação para os teus clientes"
      },
      "feat3": {
        "title": "Estatísticas de negócio",
        "desc": "Consulta informações importantes para crescer o teu negócio:",
        "check1": "Número de marcações",
        "check2": "Serviços mais requisitados pelos clientes",
        "check3": "Dados de faturação por loja e colaborador",
        "check4": "Número de visitas à página de marcações"
      },
      "feat4": {
        "title": "Acede à ficha dos teus clientes num click",
        "desc": "Acede a informações importantes sobre os teus clientes para uma experiência única:",
        "check1": "Informações de contacto, data de aniversário e observações",
        "check2": "Estatísticas de cliente (nº de marcações, faltas, cancelamentos, valor gasto)",
        "check3": "Histórico de marcações e última visita",
        "check4": "Serviços preferidos"
      },
      "feat5": {
        "title": "Gerir uma equipa nunca foi tão fácil!",
        "check1": "Acompanha a agenda e a produtividade de todos os colaboradores",
        "check2": "Horários e serviços personalizados por colaborador",
        "check3": "Personaliza o teu calendário com cores para cada serviço"
      },
      "feat6": {
        "title": "Um acesso exclusivo para os teus colaboradores",
        "desc": "Limita o acesso à agenda com diferentes permissões:",
        "check1": "Administrador",
        "check2": "Gerente",
        "check3": "Colaborador"
      },
      "feat7": {
        "title": "SMS Aniversário",
        "desc": "Mantém-te conectado com os teus clientes e envia uma mensagem de parabéns automática no seu aniversário."
      },
      "feat8": {
        "title": "SMS / E-mail marketing",
        "check1": "Cria campanhas e promoções e traz os teus clientes de volta",
        "check2": "Filtra os segementos de clientes para uma mensagem personalizada",
        "check3": "Usa os nossos templates de ideias e cria uma campanha em segundos"
      },
      "featIntegratedInvoicing": {
        "title": "Faturação integrada (opcional)",
        "desc": "Emite faturas legalmente válidas em Portugal sem sair da BUK. Modulo opcional.",
        "check1": "Emite faturas a partir de uma marcação ou registo de venda",
        "check2": "Envia por e-mail ou faz download do PDF em segundos",
        "check3": "Gere o teu negocio sem sair da BUK",
        "check4": "Faturas certificadas pela Autoridade Tributária"
      },
      "featSalesCommissions": {
        "title": "Gestão de vendas e comissões",
        "desc": "Regista vendas de serviços e produtos e acompanha pagamentos num só lugar.",
        "check1": "Regista vendas de marcações e produtos",
        "check2": "Acompanha a faturação real do teu negócio",
        "check3": "Define comissões por colaborador"
      },
      "featRoomsEquip": {
        "title": "Gestão de Salas e Equipamentos",
        "desc": "Organiza a disponibilidade de salas e equipamentos na tua agenda.",
        "check1": "Vista por sala com horários ocupados e livres",
        "check2": "Evita sobreposições de marcações no mesmo espaço",
        "check3": "Associa salas a serviços e colaboradores"
      }
    },
    "landBookingPage": {
      "hero": {
        "title": "O fim das chamadas perdidas",
        "desc": "Personaliza a tua página de marcações e partilha o link com os teus clientes. Nunca foi tão simples fazer uma marcação!"
      },
      "feat1": {
        "title": "Uma página de marcações à tua medida",
        "desc": "Personaliza a tua página de marcações com o teu logo e a tua marca.",
        "check1": "Recebe marcações 24/7",
        "check2": "Partilha o teu link de marcações com todos os teus clientes"
      },
      "feat2": {
        "title": "Personaliza o processo de marcação",
        "check1": "Links de marcação personalizáveis para cada localização / colaborador ",
        "check2": "Configura a antecedência em que permites marcações pelos clientes por exemplo: 8h, 16h, 24h",
        "check3": "Permite que os clientes marquem vários serviços na mesma marcação",
        "check4": "Solicita o pré-pagamento no acto da marcação e evita faltas de comparência"
      },
      "feat3": {
        "title": "Pagamentos online",
        "desc": "Escolhe e configura entre os vários métodos de pagamento disponíveis: MBWay, cartão de crédito, Apple Pay e Google Pay.",
        "check1": "Evita faltas de comparência com pré-pagamento online",
        "check2": "Configura o pré-pagamento online com um sinal ou pagamento total"
      },
      "feat4": {
        "title": "Google Reviews",
        "check1": "Aumenta a visibilidade do teu negócio no Google Maps",
        "check2": "Envia uma mensagem automática aos teus clientes com um link directo para as tuas reviews no Google"
      },
      "feat5": {
        "title": "A forma mais simples de estar perto dos teus clientes",
        "desc": "Adiciona o teu link de marcações em todas as plataformas: Facebook, Instagram, Google Maps, WhatsApp",
        "check1": "Reduz as notificações e telefonemas enquanto trabalhas",
        "check2": "Dedica mais tempo ao que realmente importa: os teus clientes",
        "check3": "Analisa conversões com os códigos de Google/Meta Pixel"
      },
      "feat6": {
        "title": "Programa de Fidelização",
        "desc": "Oferece prémios aos clientes mais fiéis e incentiva a próxima visita.",
        "check1": "Define o prémio e o número de visitas para o conquistar",
        "check2": "Personaliza os teus termos e condições",
        "check3": "Fortalece a relação com os teus melhores clientes"
      },
      "feat7": {
        "title": "Campos Personalizados ao teu Negócio",
        "desc": "Personaliza a página de marcações e a ficha do cliente com campos específicos para o teu negócio.",
        "check1": "Adiciona campos de Texto, Data e Multi-opções",
        "check2": "Escolhe se os campos são obrigatórios ou opcionais para marcações online"
      },
      "feat8": {
        "title": "QR Code Personalizado",
        "desc": "Simplifica o acesso à tua agenda com um QR code prático.",
        "check1": "Permite marcações rápidas com um simples scan em cartões ou flyers",
        "check2": "Coloca o teu QR code na porta, dá um toque moderno e acessível ao teu negócio"
      }
    },
    "pricing": {
      "h1": "Planos & Preços",
      "subtext": "Podes cancelar ou alterar o plano a qualquer momento.",
      "perMonth": "/ mês",
      "byProvider": "por colaborador extra",
      "freeDescription": "Usufrui gratuitamente de uma agenda digital para gerir o teu negócio.",
      "proPlanDescription": "Mais funcionalidades, envia lembretes e-mail e SMS ilimitados!",
      "proPlanDescriptionNoSMS": "Mais funcionalidades, envia lembretes e-mail ilimitados!",
      "proPlusDescription": "Potencia o teu negócio ao máximo com mais funcionalidades e customização.",
      "payAnnual": "Pagar anualmente",
      "unlimitedSMS": "SMS Ilimitados",
      "features": {
        "bookingPage": "Página de marcações",
        "advancedBookingPage": "Página de marcações personalizada",
        "calendar": "Agenda Online",
        "advancedCalendar": "Definições avançadas da agenda",
        "advancedSettings": "Mais definições e personalização",
        "email": "Lembretes e-mail Ilimitados",
        "email100": "Lembretes e-mail (100 grátis/mês)",
        "stats": "Estatísticas de negócio",
        "googleCalendar": "Sincronizar Google Calendar",
        "sms": "Lembretes SMS",
        "smsEmailUnlimited": "Lembretes e-mail/SMS Ilimitados",
        "unlimited": "Lembretes SMS Ilimitados",
        "whatsapp": "Suporte prioritário por WhatsApp",
        "one_provider": "Apenas 1 colaborador",
        "contact": "Fala connosco",
        "all_pro": "Tudo do plano Pro",
        "birthday": "SMS Aniversário",
        "marketingTools": "Ferramentas de Marketing",
        "personalizedReminders": "Lembretes personalizados",
        "marketingCredit": "5€/mês desconto em marketing",
        "marketingCredit2": "50% desconto em marketing",
        "apiAccess": "Acesso API",
        "loyalty": "Programa de fidelização",
        "websiteIntegration": "Integração website (embeded)",
        "integratedInvoicing": "Faturação integrada",
        "googleReserve": "Google Reserve",
        "googleReviews": "Google Reviews",
        "viewMore": "Ver lista completa",
        "viewLess": "Ver menos"
      },
      "enterprise": "Enterprise",
      "enterpriseLabel": "+20 colaboradores",
      "enterpriseDesc": "Cria a solução de agendamento ideal para o teu negócio, com um preço à medida, várias opções de personalização e integração – fala connosco.",
      "registerBusiness": "Registe-te grátis",
      "yearly": "Anual",
      "monthly": "Mensal",
      "payed_yearly": "Valor mensal / Pago anualmente",
      "vat_included": "IVA incluído",
      "vat_not_included": "Acresce o IVA à taxa em vigor",
      "morePopular": "Mais popular",
      "everythingFromFree": "Tudo do plano Grátis",
      "tryPro": "1 mês grátis com o código: TRYPRO",
      "vatDisclaimer": "Tem colaboradores em part-time? Fale connosco que faremos um desconto na sua mensalidade. Os preços exibidos estão sujeitos à taxa de IVA em vigor.",
      "withoutCommitment": "Sem compromisso"
    },
    "recover-pass-page": {
      "h3": "Recuperar password",
      "newPassword": "Nova password",
      "confirmPassword": "Confirmar password",
      "passwordsInvalid": "As passwords não são iguais",
      "login": "Login",
      "submit": "Enviar",
      "emailSent": "Enviamos um e-mail com instruções para recuperar a password",
      "passwordSuccess": "A password foi alterada com sucesso"
    },
    "set-password-page": {
      "h3": "Criar conta",
      "newPassword": "Nova password",
      "confirmPassword": "Confirmar password",
      "passwordsInvalid": "As passwords não são iguais",
      "login": "Login",
      "submit": "Entrar",
      "passwordSuccess": "A sua conta foi criada com sucesso"
    },
    "privacy": {
      "title": "Política de privacidade"
    },
    "unsubscribe": {
      "title": "Deseja parar de receber campanhas de e-mail?",
      "cta": "Confirmar",
      "successMessage": "Confirmado"
    },
    "terms": {
      "title": "Termos e Condições de Utilização"
    },
    "faqs": {
      "title": "Perguntas Frequentes",
      "q1": "O que é o BUK?",
      "a1": "O BUK permite que os teus clientes agendem marcações contigo em qualquer lugar e a qualquer momento, de forma autónoma, sem necessidade de telefonar ou enviar mensagens/emails.",
      "q2": "Como instalo o BUK?",
      "a2": "Não há nada para instalar. O BUK usa as mais recentes tecnologias Web para que os teus clientes possam fazer marcações a partir de qualquer dispositivo (incluindo telemóveis).",
      "q3": "Quanto tempo demora a começar?",
      "a3": "Cerca de 5 minutos — é muito rápido.",
      "q4": "De que informações preciso para começar?",
      "a4": "Precisas de uma morada (se trabalhares numa localização fixa), horários de abertura e fecho, nomes dos colaboradores, horários da tua equipa e os serviços que oferecem.",
      "q5": "O BUK é apenas para barbearias?",
      "q5b": "O BUK é apenas para",
      "a5": "De todo! O BUK é feito para qualquer negócio que precise de agendar marcações. É usado todos os dias por salões de beleza, SPAs, Personal Trainers, fisioterapeutas e muitos outros profissionais.",
      "q6": "Preciso de ter site para aproveitar o BUK?",
      "a6": "Não! Quando crias uma conta, recebes um link público BUK para partilhares com os teus clientes. Podes usá-lo nas redes sociais para direcionar os clientes para a tua página de marcações.",
      "q7": "Podem ajudar-me a configurar o BUK?",
      "a7": "Claro! Se precisares de ajuda para configurar o BUK ou tiveres alguma dúvida, entra em contacto connosco <a href=\"mailto:suporte@buk.pt\">aqui</a>.",
      "q8": "O BUK tem uma app para dispositivos móveis?",
      "a8": "O BUK usa as tecnologias Web mais recentes para que os teus clientes o possam usar em qualquer dispositivo. Não há nada para instalar. No entanto, podem facilmente adicionar a tua página de marcações ao ecrã inicial dos seus telemóveis, funcionando como uma app.",
      "q9": "Posso receber pagamentos com o BUK?",
      "a9": "Sim, mas é opcional! O BUK permite que os clientes façam o pagamento no momento da marcação via MB WAY, Apple/Google Pay ou referência de multibanco — sem custos adicionais para os clientes. Isto ajuda a evitar cancelamentos ou faltas de última hora.",
      "q10": "Posso usar o BUK para gerir uma equipa grande?",
      "a10": "Claro! Podes adicionar quantos colaboradores quiseres. Cada um terá o seu próprio calendário e poderá configurar o seu horário.",
      "q11": "Temos várias localizações. Podemos usar o BUK?",
      "a11": "Claro! Basta adicionares outra localização à tua agenda (menu no canto superior direito). Podes gerir todas as localizações no mesmo sítio, cada uma com a sua própria equipa e configurações.",
      "q12": "Quanto custa o BUK?",
      "a12": "O BUK é gratuito para um colaborador! A versão Profissional custa 17,99€ por mês para 1 colaborador, e 9€ por mês por cada colaborador adicional. Inclui funcionalidades avançadas como lembretes por SMS, sincronização com Google Calendar, multi-marcações e Google Reviews. Os pagamentos online têm uma pequena comissão para cobrir os custos das transferências. Acreditamos que este é o modelo de preço mais justo, permitindo-te manter os custos baixos.",
      "q13": "Quanto custa adicionar uma segunda localização?",
      "a13": "Para adicionares mais do que uma localização, precisas de aderir ao BUK Profissional.",
      "q14": "Existe o risco de vários clientes reservarem o mesmo serviço ao mesmo tempo?",
      "a14": "Não. Assim que um cliente conclui o processo de marcação, o BUK bloqueia esse horário. Ainda assim, podes fazer alterações no calendário sempre que quiseres.",
      "q15": "Tenho de confirmar as marcações feitas pelos meus clientes?",
      "a15": "Não. As marcações feitas pelos clientes são automaticamente confirmadas. No entanto, pedimos que os clientes indiquem o número de telefone e email para que os possas contactar, se necessário.",
      "q16": "O BUK funciona com o meu site ou perfil do Facebook?",
      "a16": "Sim! Para receber marcações a partir do teu site, basta instalar o nosso plugin para WordPress. Para o Facebook e outras redes sociais, segue as instruções no nosso guia <b><a href=\"https://blog.buk.pt/colocar-link-redes-sociais/\" target=\"_blank\">aqui</a>.</b>",
      "q17": "O que acontece se eu precisar de fechar o meu negócio por algum tempo ou estiver de férias?",
      "a17": "Podes simplesmente clicar num espaço livre no calendário, selecionar <b>Bloquear Marcações</b>, e esse horário ficará indisponível para marcações online.",
      "q18": "Posso agendar uma marcação recorrente para os meus clientes?",
      "a18": "Sim! Ao criares uma marcação no calendário, clica em <b>Repetir Marcação</b>. O BUK vai pedir que escolhas a frequência da repetição e a data final.",
      "q19": "O BUK envia lembretes aos meus clientes?",
      "a19": "Sim! Os lembretes de marcação são enviados 24 horas antes, por SMS e email — ou com antecedência personalizada.",
      "q20": "Posso reagendar uma marcação se tiver uma emergência?",
      "a20": "Pedimos que os clientes deixem o número de telefone e email para que os possas contactar e reagendar a marcação. Depois, basta editares o evento no calendário e eles serão notificados com a nova data.",
      "q21": "Tenho de definir o preço dos meus serviços?",
      "a21": "Não. Podes deixar o campo do preço vazio ao configurares os teus serviços, e o valor não aparecerá na página de marcações.",
      "q22": "Posso definir horários diferentes para a minha equipa?",
      "a22": "Sim. Cada colaborador pode ter o seu próprio horário de trabalho. Ao configurares a equipa, clica no ícone do relógio junto ao nome e edita o horário. Podes ajustá-lo sempre que quiseres.",
      "q23": "Posso adicionar um botão \"Reservar agora\" à minha página de Facebook?",
      "a23": "Claro! Vai à tua página do Facebook e edita o botão de Call To Action abaixo da imagem de capa. Escolhe a opção <b>Reservar agora</b>, clica em <b>Avançar</b> e seleciona <b>Link para página</b>. Depois, insere o teu link BUK, grava as alterações, e já está!"
    }
  },
  "CLIENT": {
    "clientCancelBooking": {
      "wishToDelete": "Deseja cancelar esta marcação?",
      "cannotCancelOnline": "Já não é possível cancelar esta marcação online",
      "contactMerchantToCancel": "Para cancelar, por favor contacte o estabelecimento.",
      "contactMerchantPhone": "Telefone:",
      "cancelledWithSuccess": "Marcação cancelada com sucesso.",
      "ctaCancelBooking": "cancelar marcação",
      "ctaNewBooking": "nova marcação",
      "paidRefundNote": "O reembolso do pagamento efetuado não é automático. Deverá contactar o responsável do estabelecimento."
    },
    "clientConfirm": {
      "title": "Confirmar marcação",
      "namePlaceholder": "Primeiro e último nome",
      "invalidPhoneNumber": "Por favor indique o seu telemóvel",
      "invalidPtNumber": "O pagamento por MBway só está disponível para números portugueses (+351)",
      "emailPlaceholder": "O seu e-mail",
      "invalidEmail": "Por favor indique o seu e-mail",
      "vatNumberPlaceholder": "NIF",
      "invalidVatNumber": "Por favor indique o seu NIF",
      "genderPlaceholder": "Género",
      "dobPlaceholder": "Data de Nascimento",
      "invalidDob": "Data de Nascimento inválida",
      "notesPlaceholder": "Observações",
      "paymentMoney": "Pagar depois",
      "mbwayNotification1": "Ao continuar irá receber uma notificação para efectuar o",
      "mbwayNotification2": "pagamento de",
      "mbNotification": "Gerar uma referência Multibanco (válida por {{time}})",
      "requiredField": "Campo obrigatório.",
      "ctaConfirmBooking": "Confirmar",
      "ctaPayBooking": "Pagar",
      "termsConditions1": "Li e concordo com os",
      "termsConditions1General": "Li e concordo com os",
      "termsConditions1b": "Li e concordo com a",
      "termsConditions2": "Termos e condições",
      "termsConditions3": "e",
      "termsConditions3b": "do BUK",
      "termsConditions4": "Política de Privacidade",
      "termsConditions4b": "da AFFLELOU.",
      "termsConditions5": "de",
      "marketingCheckbox": "Aceito receber informações comerciais e promoções adaptadas ao meu perfil e interesses.",
      "marketingCorporateCheckbox": "Aceito receber comunicações comerciais relativas a produtos e serviços de ótica ou audiologia adaptadas ao meu perfil, bem como sobre promoções, eventos ou novos produtos e serviços.",
      "termsConditionsCorporate1": "Li e aceito a Política de Privacidade",
      "termsConditionsCorporate2": "e as Condições Gerais de Uso",
      "paymentMethod": "Escolha o método de pagamento",
      "creditCard": "Cartão Crédito",
      "depositBooking": "Pré-pagamento",
      "bookingDataTitle": "Dados da marcação",
      "phoneOtpTitle": "Código de segurança",
      "phoneOtpSent": "Insira o código de 6 dígitos que enviámos por SMS para {{phone}}.",
      "phoneOtpPlaceholder": "Código SMS",
      "phoneOtpInvalid": "Introduza o código de 6 dígitos",
      "phoneOtpConfirm": "Confirmar",
      "phoneOtpResend": "Reenviar código",
      "phoneOtpResendIn": "Reenviar código em {{seconds}}s",
      "phoneOtpChangeNumber": "Alterar número",
      "phoneOtpCancel": "Cancelar"
    },
    "clientDay": {
      "title": "Escolha um dia",
      "seeMoreDates": "Ver mais datas",
      "noMoreAvailableDates": "Não existem mais datas disponíveis",
      "morning": "Manhã",
      "afternoon": "Tarde",
      "evening": "Noite",
      "noAvailability": "Não existem vagas para este mês.",
      "viewNextMonth": "Ver próximo mês"
    },
    "clientPage": {
      "newBooking": "Nova Marcação",
      "cancelBooking": "Cancelar Marcação",
      "seoTitle": "Marcações Online",
      "seoDescription": "Faça aqui a sua marcação de forma simples e rápida.",
      "footer1": "Agenda de marcações online",
      "footer2": "para todos os negócios",
      "canceled": "Cancelado",
      "noshow": "Faltou",
      "see": "Ver",
      "close": "Fechar"
    },
    "clientProviders": {
      "title": "Escolha um profissional",
      "title_multi": "Escolha um profissional para cada serviço",
      "withoutPreference": "Sem preferência"
    },
    "clientServices": {
      "title": "Escolha um serviço",
      "title_multi": "Escolha os serviços",
      "readMore": "Ler mais"
    },
    "clientStores": {
      "title": "Escolha uma opção"
    },
    "clientSuccess": {
      "title": "Confirmar marcação",
      "thankYou": "Obrigado!",
      "addToGoogleCalendar": "Adicionar ao Google Calendar",
      "addToCalendar": "Adicionar ao Outlook/Apple Calendar",
      "linkToIcal": "Subscrever o seu calendário no Outlook, Apple Calendar",
      "mbwayTitle": "Aprove o pagamento na aplicação do MBWay",
      "mbwaySuccess": "Ao efectuar o pagamento irá receber um e-mail a confirmar a sua marcação.",
      "mbwaySuccessPayOnly": "Ao efectuar o pagamento irá receber um e-mail de confirmação.",
      "mbwaySuccessAlert": "Caso não efectue o pagamento a sua marcação será cancelada.",
      "mbSuccessAlert": "Caso não efectue o pagamento nos próximos {{time}}",
      "mbSuccessAlert2": "a marcação não será concluída.",
      "mbSuccessStripeAlert": "Esta referência é válida até:",
      "viewPrintableVoucher": "Ver/Imprimir Comprovativo",
      "newBooking": "Nova marcação"
    },
    "clientPayBooking": {
      "alreadyPaid": "A marcação já se encontra paga"
    },
    "clientTime": {
      "title": "Escolha uma hora",
      "morning": "Manhã",
      "afternoon": "Tarde",
      "night": "Noite"
    },
    "clientEditor": {
      "back": "Agenda",
      "share": "Partilhar",
      "edit": "Editar",
      "preview": "Pré-visualizar",
      "bookingPage": "Página de Marcações",
      "online": "Online",
      "offline": "Offline",
      "pageOffline": "A sua página está offline",
      "pageOfflineText1": "Quando em modo Offline, os seus clientes não poderão aceder à sua página de marcações.",
      "pageOfflineText2": "Não quer receber marcações através da sua página de marcações?",
      "pageOfflineText3": "Sem problema! Pode colocar a sua página em modo Offline e continuar a gerir o seu negócio internamente através da agenda.",
      "pageOfflineText4": "Vai de férias e não quer receber marcações temporariamente?",
      "pageOfflineText5": "Não precisa de ficar Offline. Em alternativa, pode criar um Bloqueio de Tempo na sua agenda para esse período e assim evitar novas marcações.",
      "personalize": "Personalizar",
      "moreOptions": "Mais Opções",
      "titleLabel": "Título da Página",
      "titleMandatory": "O título da página é obrigatório",
      "bookingPageLink": "Link da Página de Marcações",
      "linkPlaceholder": "Link de Marcação",
      "invalidLink": "Link inválido",
      "unavailableLink": "Indisponível",
      "availableLink": "Disponível",
      "yourQRCode": "O seu Código QR",
      "yourQRCodeText": "Imprima e coloque um código QR na entrada da sua loja",
      "downloadQRCode": "Download",
      "personalizeWithYourBrand": "Personalize com a sua marca",
      "yourLogo": "O seu logótipo",
      "logoFormat": "Formato do logótipo: jpg, png (min. 640x640px)",
      "removeLogo": "Remover",
      "coverImage": "Imagem de capa",
      "useDefaultCover": "Usar padrão",
      "imageFormat": "Formato da imagem: jpg, png (min. 1200x600px)",
      "showTitleOverCoverImage": "Mostrar título sobre a imagem de capa",
      "bookingInstructions": "Instruções de Marcação",
      "showBookingInstructions": "Mostrar instruções de marcação",
      "font": "Fonte do Título",
      "backgroundColor": "Cor de fundo",
      "footerNote": "Notas de rodapé",
      "websiteAndSocialMedia": "Website e Redes Sociais",
      "facebookPage": "Página do Facebook",
      "facebookPageError": "Por favor, insira um link válido do Facebook (ex: https://facebook.com/username/)",
      "instagramPage": "Página do Instagram",
      "instagramPageError": "Por favor, insira um link válido do Instagram (ex: https://instagram.com/username/)",
      "websiteLink": "O seu website",
      "optionsText": "Opções personalizadas para a sua página de marcações",
      "allowProviderChoice": "Permitir que os clientes escolham um colaborador",
      "allowProviderChoiceText": "Se tiver mais do que um colaborador, pode permitir que os seus clientes escolham no momento da marcação.",
      "allowRandomProviders": "Permitir seleção aleatória de colaborador",
      "allowRandomProvidersText": " Mostrar opção 'Sem preferência', e o sistema atribuirá a marcação a um colaborador aleatório.",
      "serviceCategoryExpanded": "Separadores de serviços expandidos",
      "serviceCategoryExpandedText": "Se tiver separadores de serviço, pode optar por mostrá-los expandidos ou colapsados por omissão.",
      "mandatoryEmailOnBooking": "Email obrigatório ao marcar",
      "mandatoryEmailOnBookingText": "Exija que os seus clientes forneçam um endereço de email ao marcar uma consulta.",
      "showVatNumberOnBookingPage": "Mostrar campo de NIF na página de marcações",
      "showVatNumberOnBookingPageText": "Permita que os seus clientes adicionem o seu NIF ao marcar uma consulta.",
      "showGenderOnBookingPage": "Mostrar campo de Género na página de marcações",
      "showGenderOnBookingPageText": "Permita que os seus clientes adicionem o género ao marcar uma consulta.",
      "showDOBOnBookingPage": "Mostrar data de nascimento na página de marcações",
      "showDOBOnBookingPageText": "Permita que os seus clientes adicionem a data de nascimento ao marcar uma consulta.",
      "facebookTrackingPixelOrToken": "Rastreamento do Facebook",
      "facebookTrackingPixelOrTokenText": "Adicione o seu pixel de rastreamento do Facebook ou token da API de Conversão (opcional) para rastrear as suas conversões.",
      "facebookPixelId": "ID do Pixel do Facebook",
      "facebookPixelIdError": "Por favor, insira um ID de Pixel do Facebook válido",
      "facebookConversionToken": "Token da API de Conversão do Facebook",
      "facebookConversionTokenError": "Por favor, insira um token válido da API de Conversão do Facebook, deve ser um valor alfanumérico",
      "gaPropertyIdBox": "Google Analytics (GA4)",
      "gaPropertyIdBoxText": "Use o código de rastreamento do Google Analytics para capturar dados de tráfego da sua página de marcações na sua conta do Google Analytics.",
      "gaPropertyId": "Tracking ID",
      "gaPropertyIdError": "Por favor, insira um ID de Medição do Google Analytics 4 (GA4) válido no formato G-XXXXXXXX.",
      "gtmPropertyIdBox": "Google Tag Manager (GTM)",
      "gtmPropertyIdBoxText": "Use o ID do contentor do Google Tag Manager para capturar dados de tráfego e conversões da sua página de marcações na sua configuração do GTM.",
      "gtmPropertyId": "ID do Contentor",
      "gtmPropertyIdError": "Por favor, insira um ID de contentor do Google Tag Manager (GTM) válido no formato GTM-XXXXXXX.",
      "tiktokPixelBox": "TikTok Pixel",
      "tiktokPixelBoxText": "Use o ID do TikTok Pixel para capturar dados de tráfego e conversões da sua página de marcações na sua conta TikTok Ads.",
      "tiktokPixelId": "ID do TikTok Pixel",
      "tiktokPixelIdError": "Por favor, insira um ID de TikTok Pixel válido (alfanumérico, maiúsculas).",
      "saveSuccess": "Guardado com sucesso",
      "confirmClose": "Tem alterações não guardadas. Tem a certeza de que quer sair sem guardar?",
      "backToEditor": "Voltar ao Editor",
      "close": "Fechar",
      "shareOn": "Partilhar no",
      "copyShareLink": "Copiar Link de Partilha",
      "linkCopied": "Copiado",
      "shareText": "Faça a sua próxima marcação online! Use a nossa página de marcações em:",
      "shareReferralLink": "O seu link de convite",
      "shareReferralVia": "Partilhe com os seus contactos"
    }
  },
  "CORE": {
    "seo": {
      "title": "BUK | Agenda de marcações online",
      "description": "Agendamento online simples e flexível para os teus clientes."
    }
  },
  "SHARED": {
    "setupStoreProducts": {
      "guidanceTitle": "Crie e personalize os produtos disponíveis.",
      "addNew": "Novo Produto",
      "editProducts": "Editar Produtos",
      "productName": "Nome do produto",
      "invalidproductName": "Nome do produto inválido",
      "descriptionName": "Descrição do produto",
      "invalidDescription": "Escreva uma descrição para o produto com o máximo de 500 caracteres",
      "invalidPrice": "Escolha um preço",
      "vatRate": "Taxa de IVA",
      "vatRatePlaceholder": "Selecione a taxa de IVA",
      "invalidVatRate": "Taxa de IVA inválida",
      "confirmTextproduct": "Tem a certeza de que deseja remover este produto?",
      "vatExemption": "Isenção de IVA",
      "invalidVatExemption": "Por favor selecione uma isenção de IVA",
      "emptyState": "Adicione um produto para começar."
    },
    "setupStoreRooms": {
      "guidanceTitle": "Crie e personalize as suas salas ou equipamentos.",
      "emptyState": "Adicione uma sala ou equipamento para começar.",
      "addNew": "Nova Sala",
      "editRooms": "Editar Salas",
      "roomName": "Nome da sala / equipamento",
      "invalidRoomName": "Nome da sala / equipamento inválido",
      "descriptionName": "Descrição da sala / equipamento",
      "invalidDescription": "Descrição inválida",
      "confirmTextRoom": "Tem a certeza de que deseja remover esta sala / equipamento?",
      "room": "Sala",
      "equipment": "Equipamento",
      "services": "Serviços associados",
      "type": "Tipo",
      "typePlaceholder": "Sala ou equipamento",
      "servicesPlaceholder": "Selecione os serviços"
    },
    "close": "Fechar",
    "help-modal": {
      "title": "Precisa de ajuda?",
      "phone": "Telefone",
      "sms": "SMS",
      "wecanhelp": "Fale connosco.",
      "helpCenter": "Centro de Ajuda BUK"
    },
    "signup": {
      "missingEmail": "Por favor introduza o seu e-mail",
      "aboutBusiness": "Sobre o seu negócio",
      "registerSubTitle": "A informação do seu negócio pode ser alterada mais tarde nas definições da sua conta.",
      "yourAccount": "A sua conta",
      "yourBusiness": "O seu negócio",
      "yourBusinessTitle": "Registe o seu negócio em segundos!",
      "writeYourName": "Escreva o seu nome",
      "yourName": "Primeiro e último nome",
      "writeYourEmail": "Escreva o seu e-mail",
      "writeYourPhone": "Escreva o seu número de telefone",
      "writePassword": "Escolha uma password",
      "readTerms1": "Li e concordo com os",
      "readTerms2": "Termos e condições",
      "readTerms3": "e",
      "readTerms4": "Política de Privacidade",
      "register": "Registar",
      "alreadyHaveAnAccount": "Já tem uma conta?",
      "loginHere": "Faça login aqui.",
      "newCompaniesCampaingCheckboxTitle": "Novas Empresas",
      "newCompaniesCampaingDesc": "Plano Pro grátis se a sua empresa tem menos de 6 meses.",
      "newCompaniesCampaingCheckbox": "Quero candidatar-me à campanha BUK Novas Empresas"
    },
    "signup2": {
      "registerAccountSubtitle": "e configure a sua conta em segundos!",
      "registerBusinessTitle": "Registe o seu negócio",
      "registerBusinessSubtitle": "Bem-vindo/a",
      "orUseEmail": "ou use o seu e-mail",
      "logout": "Sair"
    },
    "login": {
      "login": "Entrar",
      "emailPlaceholder": "Email",
      "emailInvalidMessage": "Email inválido",
      "passwordPlaceholder": "Password",
      "passwordInvalidMessage": "Password inválida",
      "ctaLogin": "Entrar",
      "passwordNotRemember": "Não se lembra da password?",
      "clickHere": "Clique aqui.",
      "notRegisteredYet": "Ainda não tem uma conta?",
      "signupHere": "Registe-se aqui."
    },
    "setupMerchantPage": {
      "businessName": "Nome do negócio",
      "invalidBusinessName": "Por favor introduza o nome do seu negócio.",
      "slug": "Link de marcações",
      "invalidSlug": "Link inválido",
      "teamSize": "Qual o tamanho da sua equipa?",
      "teamSizeText": "Ajude-nos a melhorar a sua experiência 🪄",
      "invalidBusinessType": "Por favor seleccione o tipo de negócio",
      "unavailableLink": "Link indisponível",
      "availableLink": "Link disponível",
      "chooseCountry": "Escolha um país",
      "country": "País",
      "businessType": "Qual o seu tipo de negócio?",
      "businessTypeText": "Ajude-nos a melhorar a sua experiência 🪄",
      "invalidTeamSize": "Tamanho de equipa inválido",
      "previousSoftware": "Que software usa actualmente?",
      "previousSoftwareText": "Se está a pensar em mudar, podemos ajudar a acelerar a configuração do seu negócio e importar os seus dados para a sua nova conta BUK.",
      "discoverChannel": "Onde ouviu falar do BUK?",
      "discoverChannelText": "Ajude-nos a melhorar a sua experiência",
      "otherSoftware": "Outro",
      "noSoftware": "Não uso nenhum software",
      "friend": "Recomendado por um amigo",
      "madeBooking": "Usei para fazer uma marcação",
      "search": "Pesquisa no Google",
      "social": "Instagram / Facebook",
      "ad": "Num anúncio online",
      "other": "Outro"
    },
    "setupStoreServices": {
      "guidanceTitle": "Adicione os seus serviços:",
      "chooseCurrency": "Escolha a moeda",
      "serviceName": "Nome do serviço",
      "serviceImage": "Imagem do serviço",
      "image": "Imagem",
      "changeColor": "Alterar cor",
      "descriptionName": "Descrição do serviço",
      "invalidServiceName": "Escreva um nome para o serviço",
      "invalidDescription": "Escreva uma descrição para o serviço com o máximo de 500 caracteres",
      "name": "Nome",
      "description": "Descrição do serviço",
      "duration": "Duração",
      "customDuration": "Editar duração",
      "invalidDuration": "Escolha uma duração",
      "invalidPrice": "Escolha um preço",
      "color": "Cor",
      "categoryName": "Nome do separador",
      "invalidCategoryName": "Escreva um nome para o separador",
      "addNew": "Novo Serviço",
      "addNewCategory": "Novo Separador",
      "editCreateServices": "Editar Serviço",
      "editCreateCategory": "Editar Separador",
      "confirmTextService": "Tem a certeza que quer apagar este serviço?",
      "confirmTextCategory": "Tem a certeza que quer apagar este separador?",
      "showOnBookingPage": "Disponível na página de marcações",
      "showPriceOnBookingPage": "Mostrar preço na página de marcações",
      "generateVideoCallLink": "Gerar link de videochamada",
      "generateVideoCallLinkDescription": "Criar automaticamente um link Google Meet associado às marcações deste serviço.",
      "scheduleOverride": "Definir um horário personalizado",
      "durationExtraConfig": "Personalizar duração do serviço",
      "durationForClient": "Duração para o cliente",
      "durationForProvider": "Duração para o colaborador",
      "options": "Opções",
      "priceChange": {
        "title": "Escolha uma opção",
        "description": "Existem {{count}} marcações para este serviço no futuro que ainda não foram pagas. Quer aplicar o novo preço?",
        "newOnly": "Não, aplicar só para novas marcações",
        "alsoFuture": "Sim, aplicar para novas e existentes"
      }
    },
    "setupMultipleServices": {
      "addNew": "Nova Regra"
    },
    "setupStoreWorkplan": {
      "guidanceTitle": "Configure o horário de funcionamento.",
      "openHour": "Início",
      "closeHour": "Fim",
      "invalidCloseHour": "Escolha uma hora de fecho",
      "invalidOpenHour": "Escolha uma hora de abertura",
      "intervalsOverlap": "Os intervalos do mesmo dia não se podem sobrepor.",
      "deleteHours": "Apagar intervalo de horas",
      "addHours": "Adicionar intervalo de horas",
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb",
      "sun": "Dom",
      "providerWorkplanConflict": "Atenção: Este colaborador tem um horário diferente do horário pré-definido na loja. Para utilizar o horário da loja clique",
      "here": "aqui",
      "storeWorkplanConflictSingular": "Aviso: tem {{param}} colaborador com horário diferente deste horário da loja. As alterações que fizer nesta página não terão efeito nesse colaborador.",
      "storeWorkplanConflict": "Aviso: tem {{param}} colaboradores com horários diferentes deste horário da loja. As alterações que fizer nesta página não terão efeito nesses colaboradores.",
      "storeServiceWorkplanConflictSingular": "Aviso: tem {{param}} serviço com horário diferente deste horário da loja. As alterações que fizer nesta página não terão efeito nesse serviço.",
      "storeServiceWorkplanConflict": "Aviso: tem {{param}} serviços com horários diferentes deste horário da loja. As alterações que fizer nesta página não terão efeito nesses serviços.",
      "createExceptions": "Criar horário especial"
    },
    "setupStoreProviders": {
      "guidanceTitle": "Inscreva os seus colaboradores.",
      "addNew": "Adicionar novo",
      "directLink": "Link",
      "nameResource": "Nome do colaborador",
      "invalidNameResource": "Escreva o nome do colaborador",
      "settings": "Escolha o horário e os serviços desde colaborador(a)",
      "newProvider": "Novo colaborador",
      "editProvider": "Editar colaborador",
      "providerNoServicesError": "Por favor seleccione pelo menos um serviço",
      "goBack": "Voltar atrás",
      "addExistingProvider": "Adicionar colaborador de outra loja",
      "pickAnOption": "Escolha uma opção",
      "sharedProviderWarning": "está associado a várias lojas. Agendar uma marcação num calendário impedirá a reserva nos outros.",
      "noProvidersToAdd": "Não existem mais colaboradores para adicionar."
    },
    "setupProviderWorkplanModal": {
      "guidanceTitle": "Defina um horário para \"{{name}}\" diferente do horário de funcionamento da loja",
      "guidanceTitleNoName": "Defina o horário do colaborador",
      "schedule": "Horário"
    },
    "setupProviderServicesModal": {
      "guidanceTitle": "Selecione/Edite os serviços deste colaborador",
      "guidanceTitleNoName": "Defina os serviços para o colaborador",
      "schedule": "Serviços",
      "scheduleOverride": "Definir um horário personalizado",
      "bookingFrequencyOverride": "Intervalo de marcações personalizado para este colaborador",
      "bookingFrequencyBookingPageOnly": "Esta definição afeta apenas a página de marcações.",
      "bookingFrequencyStoreDefaultHint": "Quando desativado, usa o intervalo da loja ({{value}}).",
      "commissions": "Comissões"
    },
    "setupProviderCommissionsModal": {
      "guidanceTitle": "Selecione/Edite as comissões deste colaborador",
      "guidanceTitleNoName": "Defina as comissões para o colaborador"
    },
    "googleConnectAccount": {
      "syncWithGoogleCalendar": "Google Calendar",
      "syncWithGoogleCalendarDescription": "As suas marcações vão aparecer no seu calendário Google automaticamente.",
      "syncWithGoogleCalendarError": "Não foi possível sincronizar com o Google Calendar. Por favor tente novamente.",
      "syncedWith": "Sincronizado com {{email}}",
      "sync": "Sincronizar",
      "stopSync": "Parar"
    },
    "googleConnectReview": {
      "modalTitle": "Conectar negócio",
      "searchLabel": "Encontre o seu negócio no Google Maps:",
      "testLink": "Testar link",
      "saveLink": "Gravar"
    },
    "googleReserve": {
      "title": "Google Reserve",
      "desc": "Atraia mais clientes ao permitir reservas diretas através do Google",
      "cta": "Configurar",
      "price": "2.99€/mês",
      "freeUntil": "Grátis até 10/2023",
      "activate": "Activar extensão",
      "deactivate": "Desactivar extensão",
      "active": "Activo",
      "inactive": "Inactivo",
      "notBeauty": "Extensão apenas disponível para negócios de beleza",
      "askForHelp": "Pedir ajuda",
      "success": "Extensão activa! Atenção, esta pode demorar até 48 horas a ter efeito.",
      "warning": "Atenção, alguns serviços não estão disponíveis no Google Reserve por não terem um preço configurado.",
      "error": "Atenção! Para activar a extensão tem de configurar um preço nos seus serviços. Após configurar, a extensão pode demorar até 48 horas a ter efeito.",
      "modalConfirmDeactivate1": "Atenção! Ao desactivar esta funcionalidade está a perder uma ferramenta crítica para o seu negócio.",
      "modalConfirmDeactivate2": "Os seus clientes não irão conseguir agendar através da integração com o Google",
      "modalConfirmActivate1B": "Esta extensão tem um custo mensal de 2.99€. ",
      "modalConfirmActivate1": "Pode activar ou desactivar a qualquer momento sem compromisso.",
      "modalConfirmActivate2": "Grátis até 10/2023 🥳",
      "modalConfirmActivate2desc": "Não será cobrado até dia 1 de Outubro de 2023, pode cancelar a qualquer momento desactivando esta funcionalidade.",
      "continue": "Continuar",
      "goBack": "Voltar atrás"
    },
    "googleReviews": {
      "title": "Google Reviews",
      "desc": "Envie uma mensagem automática para os seus clientes deixarem uma avaliação no Google após a sua visita",
      "cta": "Configurar",
      "price": "2.99€/mês",
      "freeUntil": "Grátis até 10/2023",
      "activate": "Activar extensão",
      "deactivate": "Desactivar extensão",
      "active": "Activo",
      "inactive": "Inactivo",
      "success": "Extensão activa!",
      "modalConfirmDeactivate1": "Atenção! Ao desactivar esta funcionalidade está a perder uma ferramenta crítica para o seu negócio.",
      "modalConfirmDeactivate2": "Os seus clientes não irão receber uma mensagem para deixarem uma avaliação no Google após a sua visita",
      "modalConfirmActivate1B": "Esta extensão tem um custo mensal de 2.99€. ",
      "modalConfirmActivate1": "Pode activar ou desactivar a qualquer momento sem compromisso.",
      "modalConfirmActivate2": "Grátis até 10/2023 🥳",
      "modalConfirmActivate2desc": "Não será cobrado até dia 1 de Outubro de 2023, pode cancelar a qualquer momento desactivando esta funcionalidade.",
      "continue": "Continuar",
      "goBack": "Voltar atrás"
    },
    "websiteIntegration": {
      "title": "Integração Website (Embed)",
      "desc": "Adicione uma secção de marcações no seu website com um código embed.",
      "cta": "Configurar"
    },
    "loyaltyPage": {
      "title": "Programa de Fidelização",
      "desc": "Fidelize os seus clientes através de um sistema de contabilização de pontos / visitas e ofertas de promoções",
      "desc2": "Atenção, o programa de fidelização é activado independentemente para cada loja.",
      "cta": "Configurar",
      "inactive": "Inactivo",
      "success": "Já está na lista de espera. Iremos entrar em contacto quando for possível aceder a esta funcionalidade.",
      "termsPlaceholder": "O programa de fidelização é aberto a todos os clientes que utilizem os nossos serviços. A participação é voluntária, e o programa pode ser alterado ou encerrado a qualquer momento, sem aviso prévio. \n\nOs prémios são atribuídos com base no número de visitas ou marcações realizadas. Cancelamentos ou faltas sem aviso prévio não serão considerados para o programa. A empresa reserva-se o direito de ajustar as condições em caso de abuso.\n\nOs prémios devem ser reclamados num prazo máximo de 60 dias após a sua atribuição e utilizados de acordo com as regras definidas pela empresa. Qualquer uso indevido ou fora do prazo pode resultar na perda dos prémios acumulados.",
      "visits": "Visitas",
      "visit": "Visita",
      "active": "Activo",
      "deactivate": "Desactivar",
      "cancel": "Cancelar",
      "terms": "Termos e condições",
      "invalidTerms": "Termos e condições inválidos",
      "configuration": "Configurações",
      "configurationDesc": "Configure o seu plano de fidelização de acordo com o seu negócio",
      "invalidValue": "Valor inválido",
      "prizeName": "Nome do prémio",
      "defaultName": "50% de Desconto",
      "invalidName": "Nome inválido",
      "faqs": "Perguntas Frequentes",
      "faqs_q1": "Como funciona o Programa de Fidelização?",
      "faqs_r1": "O Programa de Fidelização contabiliza automaticamente cada visita concluída pelos seus clientes. Quando o cliente atinge o número de visitas necessárias para o prémio, ele recebe um email a congratulá-lo, juntamente com as instruções para reclamar o prémio na próxima visita.",
      "faqs_q2": "O que acontece se o cliente faltar à marcação?",
      "faqs_r2": "Caso o cliente não compareça - marque <Falta> na marcação, e assim esta visita não será contabilizada no programa de fidelização. Apenas as visitas não marcadas como <Falta> contam para a progressão.",
      "faqs_q3": "Como o cliente acompanha o progresso no programa?",
      "faqs_r3": "Após cada visita, o cliente recebe um email com o número de visitas realizadas até ao momento, para que possa acompanhar facilmente o progresso até ao prémio.",
      "faqs_q4": "Como o cliente recebe o prémio?",
      "faqs_r4": "Quando o cliente atinge o número de visitas necessárias para ganhar o prémio, recebe um email a congratulá-lo, com os detalhes do prémio. ",
      "faqs_q5": "Como identificar as marcações com prémios no backoffice?",
      "faqs_r5": "No backoffice, as marcações que incluem prémios são sinalizadas com um ícone de troféu, facilitando a identificação. Nas marcações normais, também é possível ver a contagem de visitas do cliente, indicada igualmente por um ícone de troféu.",
      "faqs_q6": "O que fazer se o cliente não receber o email de acompanhamento?",
      "faqs_r6": "Se o cliente não receber o email de acompanhamento após a visita, sugerimos que verifique a pasta de spam ou lixo eletrónico. Caso o problema persista, entre em contacto com o nosso suporte.",
      "visitsDesc": "Em que visita recebe o cliente recebe o prémio?",
      "prizeNameDesc": "Ex. \"Serviço grátis\", \"Voucher de 10€\"",
      "termsDesc": "Este campo é utilizado para comunicar de forma clara as regras do seu programa de fidelização aos seus clientes. Leia com atenção e adapte conforme necessário.",
      "cancelModalTitle": "Desativar Programa de Fidelização",
      "cancelModalDesc1": "Atenção! Ao desativar, está a interromper o sistema de recompensas para os seus clientes.",
      "cancelModalDesc2": "Todo o seu progresso será pausado, e as suas visitas não serão contabilizadas no Programa de Fidelização. Não se esqueças de informar os seus clientes.",
      "successModalTitle": "Boa! O Programa foi activado.",
      "successModalDesc1": "Agora, cada visita será registada no Programa de Fidelização. Poderá acompanhar o progresso através das fichas dos clientes ou nas marcações realizadas.",
      "successModalDesc2": "Após cada visita, o cliente recebe um email com o número de visitas realizadas até ao momento.",
      "prize": "Prémio",
      "editPoints": "Edite os pontos de visitas de",
      "editPointsInvalid": "O número de pontos deve ser menor ou igual que"
    },
    "rgpdPage": {
      "title": "RGPD Digital",
      "desc": "Organize os dados dos seus clientes através de um sistema digital ao abrigo da lei de protecção de dados.",
      "desc2": "Esta funcionalidade ainda não está disponivel e terá o preço extra de 2.99€ / mês adicionado à sua subscrição do plano Pro.",
      "cta": "Configurar",
      "price": "2.99€/mês",
      "inactive": "Inactivo",
      "success": "Já está na lista de espera. Iremos entrar em contacto quando for possível aceder a esta funcionalidade.",
      "cta2": "Entrar na lista de espera"
    },
    "paymentsPage": {
      "title": "Pagamentos Online",
      "desc": "Garanta o compromisso dos seus clientes, evite faltas aceitando pagamentos de um sinal dos seus clientes na marcação via MB WAY, Cartão de crédito, Apple Pay, Google Pay",
      "advantage1": "Pagamento opcional ou obrigatório no acto da marcação",
      "advantage2": "Receba um sinal para o cliente garantir a vaga. Escolha a percentagem que deseja receber",
      "advantage3": "Pagamentos para a sua conta bancária no dia seguinte",
      "advantage4": "Não necessita de uma subscrição PRO",
      "percentage": "Percentagem",
      "fixedValue": "Valor fixo (€)",
      "cta": "Configurar",
      "price": "Comissão 1.9% + 0.50€",
      "comission": "Comissão",
      "comissionFinalDesc": "por pagamento efectuado online.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "active": "Activo",
      "inactive": "Inactivo",
      "configurated": "Activo",
      "notConfigurated": "Não configurado",
      "paymentMethods": "Métodos de pagamento",
      "choosePaymentMethods": "Escolha os métodos de pagamento preferidos dos seus clientes",
      "paymentsStripe": "Cartão, Apple/Google pay",
      "paymentsMBWay": "MBWay",
      "paymentsMBWayDesc": "Contactar suporte@buk.pt",
      "paymentOptions": "Opções de pagamento",
      "mandatoryPaymentTitle": "Pré-pagamento obrigatório",
      "mandatoryPaymentText": "Pagamento obrigatório para o seu cliente efectuar a marcação",
      "depositPaymentTitle": "Configurar sinal",
      "depositPaymentText": "Escolha o valor a ser cobrado ao seu cliente por cada serviço",
      "successMessage": "Definições de pagamento gravadas com sucesso",
      "configPaymentsdWarning": "Configure um método de pagamento",
      "configStripeWarning": "A configuração da sua Conta Bancária está incompleta ou pendente.",
      "someServicesDoNotHavePrice": "Atenção, alguns serviços não estão disponíveis para pagamento por não terem um preço configurado",
      "allServicesDoNotHavePrice": "Atenção! Para activar a extensão tem de configurar um preço nos seus serviços",
      "faqTitle": "Perguntas Frequentes",
      "faqTitle1": "Quando recebo o meu dinheiro de pagamentos MBWAY?",
      "faqDesc1": "Os pagamentos MBWAY serão transferidos para a sua conta do Stripe até 3 dias úteis após o pagamento. Irá depois receber no IBAN fornecido no Stripe consoante a periodicidade escolhida.",
      "faqTitle2": "O que tenho de pagar?",
      "faqDesc2": "Será cobrada apenas uma comissão de 1.9% + 0.50€ por transação em todos os pagamentos processados através do BUK.",
      "faqTitle3": "Como recebo o meu dinheiro?",
      "faqDesc3": "Todos os pagamentos serão transferidos para o IBAN fornecido no Stripe com a dedução da comissão.",
      "faqTitle4": "Tem mais alguma questão?",
      "faqDesc4": "Contacte-nos em",
      "faqDesc42": "ou através do",
      "faqTitle5": "Como posso fazer um reembolso?",
      "faqDesc5": "O BUK não efectua reembolsos automaticamente. Em caso de cancelamento deverá efectuar o reembolso do valor directamente ao seu cliente.",
      "faqTitle6": "Quando recebo o meu dinheiro?",
      "faqDesc6": "Para alterar a periodicidade (dia, semana, mês) dos depósitos basta efectuar essa configuração no Stripe.",
      "modalConfirmDeactivate1": "Atenção! Ao desactivar esta funcionalidade está a perder uma ferramenta crítica para o seu negócio.",
      "modalConfirmDeactivate2": "Os seus clientes não irão conseguir efectuar pagamentos na sua página de marcações.",
      "goBack": "Voltar atrás",
      "someServiceWithNoPrice": "Tem um serviço que não tem preço definido. Para corrigir esta situação vá a Definições > Serviços.",
      "prePaymentOptions": "Opções de Pré-pagamento",
      "prePaymentOptionsDesc": "Configure regras para pagamentos online como pré-pagamento obrigatório ou um valor mínimo de sinal.",
      "bankAccount": "Conta Bancária",
      "bankAccountDesc": "Configure a sua conta bancária para receber dinheiro dos seus pagamentos online.",
      "notConfigured": "Não configurado",
      "emailInfo": "Email de acesso",
      "bank": "Banco"
    },
    "extensions": {
      "pageTitle": "Extensões",
      "pageDesc": "Eleve o seu negócio com as nossa extensões ⚡️",
      "active": "Activo",
      "viewExtensions": "Ver extensões"
    },
    "teyaTerminal": {
      "title": "Terminal Teya",
      "desc": "Peça um terminal de pagamentos Teya e automatize os pagamentos no balcão.",
      "cta": "Ver mais",
      "ctaBoxDesc": "Enviamos o terminal e activamos a integração em menos de 24h."
    },
    "navbar": {
      "statistics": "Estatísticas",
      "reports": "Relatórios",
      "agenda": "Agenda",
      "invoicing": "Facturação",
      "clients": "Clientes",
      "settings": "Definições",
      "marketing": "Marketing",
      "extensions": "Extensões",
      "help": "Ajuda?",
      "subscription": "Subscrição",
      "logout": "Sair",
      "week": "Semana",
      "shareLink": "Partilhar",
      "downloadQR": "Download QR Code",
      "linkCopied": "Link copiado",
      "editPage": "Editar página",
      "viewPage": "Ver página",
      "usingFreePlan": "Está a usar o <strong>Plano Grátis</strong>",
      "mobilePro1": "Ative o Plano PRO",
      "mobilePro2": "Plano PRO: Pague 1 mês, utilize 3.",
      "mobilePro3": "Mais funcionalidades e maior personalização!",
      "becomePro": "SER PRO",
      "pastFreeTrial": "O período gratuito terminou, para continuar active a sua subscrição.",
      "pastDue": "A sua subscrição expirou por pagamento falhado. Para poder continuar a usufruir de todas as funcionalidades do BUK corrija o seu método de pagamento.",
      "activateSubscription": "Activar subscrição",
      "trialingDaysLeft": "Faltam <strong>{{trialingDaysLeft}} dias</strong> para terminar o seu período gratuito. Para continuar após este período active a sua subscrição.",
      "ignore": "Ignorar",
      "subscriptionCancelled": "A sua subscrição foi cancelada. Ative-a para poder continuar a usar todas as funcionalidades do BUK",
      "freePlanBanner": "Psst... Agora existe um novo Plano Profissional para 1 colaborador. 👀",
      "seePlan": "Ver Plano",
      "shareOn": "Partilhar no",
      "copyCode": "Copiar link",
      "shareText": "Ganhe 50% de desconto durante 6 meses em qualquer plano PRO da BUK - Agenda de Marcações Online - com o meu código:",
      "timeAgo": "há {{value}}",
      "bookDemo": "Marcar ",
      "bookDemo2": "Demo",
      "addToHomescreenCta": "Adicionar ao Homescreen",
      "addToHomescreenCtaSubtitle": "Crie um atalho no seu ecrã principal",
      "sales": "Vendas"
    },
    "addToHome": {
      "title": "Adicionar ao Homescreen",
      "ios1": "Navegue para a sua agenda e clique no botão de partilhar na barra de endereço.",
      "ios2": "Na lista de opções de partilha, por baixo das sugeridas, escolha “Adicionar ao ecrã principal” ou “Add to Home screen”.",
      "android1": "Navegue para a sua agenda e clique no botão de “mais opções”",
      "android2": "Na lista de opções de partilha, por baixo das sugeridas, escolha “Adicionar ao ecrã principal” ou “Add to Home screen”"
    },
    "selectStore": {
      "invite": "Plano PRO grátis",
      "subscription": "Subscrição",
      "logout": "Sair",
      "new": "Nova",
      "account": "A minha conta",
      "help": "Ajuda",
      "addNewStore": "Nova Loja ou Calendário"
    },
    "addStore": {
      "title": "Adicionar",
      "storeNameLabel": "Nome da Loja",
      "storeNamePlaceholder": "Nome",
      "storeNameInvalidMessage": "Por favor introduza o nome do estabelecimento.",
      "addressLabel": "Morada",
      "addressPlaceholder": "Morada",
      "addressInvalidMessage": "Por favor introduza a morada.",
      "ctaCancel": "Cancelar",
      "ctaCreate": "Criar"
    },
    "confirmDeleteRecurrence": {
      "title": "Está a apagar um evento recorrente.",
      "deleteOnlyThis": "Apagar só este",
      "deleteAll": "Apagar todos"
    },
    "confirmDeleteMultiple": {
      "title": "Está a apagar um evento com múltiplos serviços.",
      "deleteOnlyThis": "Apagar só este serviço",
      "deleteAll": "Apagar todos"
    },
    "confirmRemoveProvider": {
      "title": "Remover",
      "cancelAll": "Remover e cancelar marcações",
      "notifyClient": "Notificar clientes do cancelamento",
      "transferTo": "Transferir para",
      "desc1": "Este colaborador ainda tem 1 marcação como deseja proceder?",
      "desc2": "Este colaborador ainda tem {{bookings}} marcações como deseja proceder?"
    },
    "createBookingModal": {
      "newBooking": "Nova marcação",
      "editBooking": "Editar marcação",
      "booking": "Marcação",
      "openVideoCall": "Abrir videochamada",
      "multiBooking": "Esta marcação faz parte de uma sequência",
      "pastBookingWarning": "Atenção está a fazer uma marcação no passado.",
      "newClientWarning": "Sem cliente selecionado. Irá criar uma nova ficha de cliente.",
      "bookingOutOfBusinessHours": "Atenção: Marcação fora do horário.",
      "bookingConflictHours": "Atenção: O colaborador já tem uma marcação neste horário.",
      "bookingRoomEquipmentConflictHours": "Atenção: Esta sala/equipamento está ocupada neste horário.",
      "service": "Serviço",
      "selectServiceInvalid": "Por favor seleccione um serviço",
      "selectServicePlaceholder": "Escolha um serviço",
      "client": "Cliente",
      "clientPlaceholder": "Nome do cliente",
      "clientInvalid": "Por favor indique o nome do cliente",
      "clientNameMaxLength": "O nome do cliente deve ter no máximo 255 caracteres",
      "phoneLabel": "Telemóvel",
      "emailLabel": "E-mail",
      "emailPlaceholder": "Email do cliente",
      "emailInvalid": "Por favor indique o email do cliente",
      "vatNumberLabel": "NIF",
      "vatNumberPlaceholder": "NIF do cliente",
      "vatNumberInvalid": "Por favor indique o NIF do cliente",
      "providerLabel": "Colaborador",
      "providerPlaceholder": "Escolha um colaborador",
      "providerInvalid": "Por favor seleccione um colaborador",
      "notesLabel": "Observações",
      "notesPlaceholder": "Observações",
      "hourPlaceholder": "Hora",
      "hours": "Horas",
      "hour": "Hora",
      "minutes": "Minutos",
      "hourInvalid": "Por favor seleccione uma hora",
      "durationPlaceholder": "Duração",
      "duration": "Duração",
      "durationInvalid": "Por favor seleccione a duração",
      "notifyClient": "Notificar cliente",
      "sendPaymentLink": "Incluir link de pré-pagamento",
      "repeatBooking": "Repetir marcação",
      "frequency": "Frequência",
      "until": "Até",
      "saveBooking": "Gravar",
      "createBooking": "Marcar",
      "deleteBooking": "Apagar",
      "everyWeek": "Todas as semanas",
      "everyNWeek": "De {{N}} em {{N}} semanas",
      "monthlyOnDay": "No dia {{day}} de cada mês",
      "monthlyOnNthWeekday": "Na {{ordinal}} {{weekday}} de cada mês",
      "monthlyOnNthWeekdayMasculine": "No {{ordinal}} {{weekday}} de cada mês",
      "monthlyOnLastWeekday": "Na última {{weekday}} de cada mês",
      "monthlyOnLastWeekdayMasculine": "No último {{weekday}} de cada mês",
      "recurrenceOrdinal": {
        "1": "1.ª",
        "2": "2.ª",
        "3": "3.ª",
        "4": "4.ª"
      },
      "recurrenceOrdinalMasculine": {
        "1": "1.º",
        "2": "2.º",
        "3": "3.º",
        "4": "4.º"
      },
      "recurrenceWeekday": {
        "0": "domingo",
        "1": "segunda-feira",
        "2": "terça-feira",
        "3": "quarta-feira",
        "4": "quinta-feira",
        "5": "sexta-feira",
        "6": "sábado"
      },
      "date": "Data",
      "notifyClientConfirm": "Deseja notificar o cliente da alteração de horário?",
      "chooseCountry": "Procurar país...",
      "addService": "Mais serviços",
      "missedBooking": "Faltou",
      "notMissedBooking": "Não faltou",
      "moreFields": "Mais campos",
      "lessFields": "Menos campos",
      "toBePaid": "Por pagar",
      "paidOnline": "Pago online",
      "created": "Criada",
      "source": {
        "backOffice": "via Backoffice",
        "googleReserve": "via Google Reserve",
        "bookingPage": "via Online"
      },
      "paymentMethods": {
        "money": "Dinheiro",
        "mbway": "MBWay",
        "ccard": "Cartão",
        "googlepay": "Google Pay",
        "applepay": "Apple Pay",
        "paypal": "Paypal",
        "mbref": "Multibanco",
        "null": "-"
      },
      "pay": "Pagar",
      "saleRecord": "Registo de venda",
      "prePaymentLink": "Link de pré-pagamento",
      "seeRegister": "Ver registo",
      "roomEquipment": "Sala / Equipamento",
      "selectRoomEquipmentPlaceholder": "Sem sala / equipamento"
    },
    "createInvoiceModal": {
      "invoice": "Emitir fatura",
      "invoiceCta": "Faturar",
      "terminalPay": "Pagar",
      "vat": "NIF (opcional)",
      "paymentMethod": "Método de pagamento",
      "emailLabel": "Email do cliente (opcional)",
      "emailPlaceholder": "Email do cliente",
      "nameLabel": "Nome do cliente (opcional)",
      "namePlaceholder": "Nome do cliente",
      "addService": "Adicionar Serviço",
      "invalidVat": "O contribuinte inserido não é válido",
      "isentionReason": "Razão de isenção de IVA",
      "newSale": "Nova Venda"
    },
    "SIMPLE_PAYMENT_MODAL": {
      "amountLabel": "Valor a cobrar",
      "amountPlaceholder": "0,00",
      "bookingAmount": "Valor da marcação",
      "method": "Método",
      "sendToTerminal": "Enviar para o Terminal",
      "teyaTerminal": "Terminal Teya",
      "waitingPayment": "A aguardar pagamento no terminal",
      "paymentReceived": "Pagamento recebido",
      "paymentFailed": "O pagamento falhou",
      "paymentFailedDescription": "Não foi possível concluir o pagamento. Pode tentar novamente.",
      "paymentTimeout": "O pagamento expirou",
      "send": "Enviar",
      "invoiceTitle": "Emitir fatura",
      "invoiceDescription": "Poupe tempo com o módulo de Faturação Buk — emita faturas certificadas a partir dos pagamentos.",
      "learnMore": "Saber mais"
    },
    "createHolidayModal": {
      "title": "Bloquear Marcações",
      "startDateLabel": "Inicio",
      "endDateLabel": "Fim",
      "providerLabel": "Colaborador",
      "providerPlaceholder": "Seleccione um colaborador",
      "providerInvalid": "Por favor seleccione um colaborador",
      "reasonLabel": "Observações",
      "reasonPlaceholder": "Observações",
      "reasonMaxLength": "As observações devem ter no máximo 500 caracteres",
      "recurrentEvent": "Evento recorrente",
      "repeatLabel": "Repetir",
      "until": "Até",
      "ctaSave": "Gravar",
      "ctaBlock": "Bloquear",
      "ctaDelete": "Apagar",
      "everyWeek": "Todas as semanas",
      "everyNWeek": "De {{N}} em {{N}} semanas",
      "invalidEndDate": "Data de fim deve ser depois da data de início",
      "allProviders": "Todos os colaboradores"
    },
    "paymentModal": {
      "title": "Activar plano",
      "noAccess": "Apenas o administrador da conta pode gerir a subscrição. Contacte o administrador para corrigir o método de pagamento.",
      "validUntil": "Válido até",
      "couponCode": "Código de Desconto",
      "couponCodePlaceholder": "Inserir Código de Desconto",
      "couponCodeInvalid": "Código de Desconto inválido",
      "activate": "Activar",
      "changeCard": "Alterar cartão",
      "changePaymentMethod": "Alterar método de pagamento",
      "creditCardNumberLabel": "Cartão",
      "sepaName": "Nome do titular da conta",
      "invalidSepaName": "Nome do titular da conta inválido",
      "sepaLabel": "IBAN",
      "changeSepa": "Alterar IBAN",
      "mandateAcceptance": "Ao fornecer as informações de pagamento e confirmar este pagamento, autoriza (A) a Untold Ventures, Lda e a Stripe, a nossa prestadora de serviços de pagamento e/ou a PPRO, a sua prestadora de serviços local, a enviar instruções ao seu banco para debitar a conta e (B) o banco a debitar a conta de acordo com essas instruções. Como parte dos direitos, tem direito a um reembolso do banco nos termos e condições do acordo com o banco. Um reembolso deve ser solicitado dentro de 8 semanas a partir da data em que a conta foi debitada. Os direitos são explicados numa declaração que se pode obter junto do banco. Você concorda em receber notificações de futuros débitos até 2 dias antes de ocorrerem.",
      "stripeIncorrectNumber": "O número do cartão está incorrecto.",
      "stripeInvalidNumber": "O número do cartão não é válido.",
      "stripeinvalidExpiryNumber": "O mês de validade do cartão é inválido.",
      "stripeInvalidExpiryYear": "O ano de validade do cartão é inválido.",
      "stripeInvalidCVC": "O código de segurança é inválido.",
      "stripeExpiredCard": "O cartão expirou.",
      "stripeIncorrectCVC": "O código de segurança é incorrecto.",
      "stripeIncorrectZip": "O código postal falhou a validação.",
      "stripeCardDeclined": "O cartão foi rejeitado.",
      "stripeMissing": "O cliente não tem cartão associado.",
      "stripeProcessingError": "Ocorreu um erro no processamento do cartão.",
      "successPayment": "Pagamento recebido 🎉 O seu plano já se encontra activo. Boas marcações!",
      "successPaymentTitle": "Pagamento recebido 🎉",
      "successPaymentMsg": "Sabia que pode convidar amigos e ganhar 100€?",
      "successPaymentMsg2": "Poupe na sua subscrição e ofereça um desconto a um amigo que tenha um negócio.",
      "successPaymentInviteFriends": "Convidar Amigos",
      "vatNumber": "NIPC/NIF (opcional)",
      "vatNumberPlaceholder": "NIPC/NIF",
      "vatNumberInvalid": "NIPC/NIF inválido (ex: {{value}}999999999)",
      "successUpdatePaymentMethod": "Método de pagamento atualizado",
      "successDiscountCode": "Código de desconto inserido com sucesso!",
      "backToCalendar": "Voltar para a agenda",
      "mbwayNotification1": "Irá receber uma notificação na app MBWay para efectuar o",
      "mbwayNotification2": "pagamento de",
      "sepaNotAllowed": "Este método de pagamento não está disponível devido ao elevado número de tentativas de cobrança falhadas. Por favor utilize outro método de pagamento.",
      "phoneMbway": "Número de MBWay",
      "pay": "Pagar",
      "backToPlans": "Ver planos",
      "plan": "Plano {{value}}",
      "youAreSaving": "Está a poupar",
      "paymentMethod": "Método de pagamento",
      "paymentPeriod": "Periodo de subscrição",
      "vat": "IVA",
      "totalMonthly": "Total Mensal",
      "totalYearly": "Total Anual",
      "subscription": "Subscrição",
      "payNow": "Pagar agora",
      "cancel": "Cancelar",
      "waitingMBWayPayment": "A aguardar o pagamento MBWay...",
      "authorizeMBWayPayment": "Autorize o pagamento no seu telemóvel",
      "waitingPayment": "A aguardar o pagamento...",
      "mbrefEntity": "Entidade:",
      "mbrefReference": "Referência:",
      "mbrefAmount": "Valor:",
      "referralText": "Desconto de recomendação aplicado!",
      "referralText2": "50% de desconto durante 6 meses",
      "referralDiscount": "Desconto (Recomendação)",
      "errorCoupon": "O código de desconto não é válido.",
      "discountCodeLabel": "Desconto (Código)",
      "discountApplied": "Desconto aplicado!",
      "for": "durante",
      "months": "mes(es)"
    },
    "paymentFlashCampaignModal": {
      "header": "PROMOÇÃO LIMITADA 72H",
      "title1": "Plano Pro 3 meses",
      "title2": "pelo preço de 1!",
      "pay": "Pagar",
      "offerEndsIn": "Oferta expira em",
      "onlyAvailable": "Só diponível em MBWay",
      "nextPayment": "Próximo pagamento:",
      "payNow": "Pague agora",
      "aboutPROPlan": "Sobre o Plano Pro"
    },
    "discountCodePage": {
      "howManyProviders": "Quantos colaboradores?"
    },
    "plansModal": {
      "title": "Subscrição",
      "planUsing": "Está a usufruir do",
      "planName": "Plano {{nickname}}",
      "free": "Grátis",
      "professional": "Pro",
      "professionalPlus": "Pro+",
      "planBookingPage": "Página de marcações",
      "planOnlineAgenda": "Agenda Online",
      "planEmailReminders": "Lembretes E-mail Ilimitados",
      "planEmailReminders100": "Lembretes e-mail (100 grátis/mês)",
      "plan1Provider": "1 Colaborador",
      "planStats": "Estatísticas",
      "syncGoogleCalendar": "Sincronizar Google Calendar",
      "planSMSReminders": "Lembretes SMS",
      "activePlan": "PLANO ACTIVO",
      "cancelSubscription": "CANCELAR SUBSCRIÇÃO",
      "haveMoreThanPossibleProviders": "Tem {{numberOfProviders}} colaboradores activos, este plano só permite um colaborador.",
      "activatePlan": "CONTINUAR",
      "useBukWithoutLimits": "Use o BUK sem limites com o Plano Pro.",
      "until": "Até",
      "provider": "Colaborador",
      "providers": "Colaboradores",
      "haveMoreThanNPossibleProviders": "Tem {{numberOfProviders}} colaboradores activos e o plano selecionado só permite {{providersAmount}}, <b>para continuar tem de remover colaboradores.</b>",
      "chooseProvidersToRemove": "Escolher colaboradores para remover",
      "forMoreThan": "Para mais do que",
      "contactUs": "entre em contacto connosco por",
      "or": "ou",
      "downgradeToFree": "Tem a certeza que quer continuar? Irá perder todas as funcionalidades do Plano Profissional.",
      "downgradeFromProPlus": "Tem a certeza que quer continuar? Irá perder as funcionalidades exclusivas do Plano Pro+:",
      "with-sms": "Com SMS",
      "without-sms": "Sem SMS",
      "annual-plan": "Anual",
      "paid-annual-plan": "Anual (-20%)",
      "paid-monthly-plan": "Mensal",
      "credit-card": "Cartão",
      "direct-debit": "Débito directo"
    },
    "upgradePlanModal": {
      "title": "Alterar plano",
      "toAdd": "Para adicionar",
      "moreProviders": "mais colaboradores",
      "needToUpdatePlan": "tem de actualizar o seu plano actual.",
      "toSync": "Para usar a sincronização com",
      "toUse": "Para usar",
      "toSee": "Para ver",
      "seePlans": "Ver mais planos",
      "ctaUpdatePlan": "Alterar agora",
      "recurringAppointment": "marcações recorrentes",
      "stats": "estatísticas",
      "posSettings": "integração de faturação",
      "multiBooking": "marcação de múltiplos serviços",
      "sms": "lembretes SMS",
      "customBookingPage": "Página de marcações personalizada",
      "footerNote": "personalização da mensagem de rodapé",
      "calendarSettings": "configurações da agenda",
      "customEmail": "personalização de emails",
      "serviceCategory": "separadores de serviços",
      "serviceImage": "imagens dos serviços",
      "googleReserve": "Google Reserve",
      "googleReviews": "Google Reviews",
      "websiteEmbed": "Integração no seu website (embed)",
      "needToUpdatePlanToPlus": "tem que actualizar o seu plano actual para o Plano Pro+."
    },
    "chooseBookOrBlockModal": {
      "newAppointment": "Nova Marcação",
      "blockTime": "Bloquear Marcações",
      "teyaSoloPay": "Novo pagamento"
    },
    "chooseProvidersToRemoveModal": {
      "title": "Escolher colaboradores para remover",
      "subtitle": "Selecione os colaboradores que pretende remover para continuar com a seleção do seu plano",
      "loadingProviders": "A carregar colaboradores...",
      "warningMessage": "<b>Atenção! Ao remover colaboradores:</b><br/>- As suas marcações irão desaparecer<br/>- Os utilizadores irão perder os acessos",
      "goBack": "Voltar atrás",
      "removeNow": "Remover agora",
      "successTitle": "Colaboradores removidos com sucesso",
      "successMessage": "Os colaboradores selecionados foram removidos com sucesso. Agora já pode atualizar a sua subscrição.",
      "viewPlans": "Ver planos",
      "errorLoadingProviders": "Erro ao carregar colaboradores. Tente novamente.",
      "errorRemovingProviders": "Erro ao remover colaboradores. Tente novamente."
    },
    "userRoles": {
      "admin": "Administrador",
      "admin_note": "[acesso geral a todas as Lojas, Menus e Definições]",
      "manager": "Gerente",
      "manager_note": "[acesso limitado apenas a esta Loja, sem acesso ao menu de Estatísticas]",
      "store": "Computador da Loja",
      "provider": "Colaborador",
      "provider_note": "[acesso limitado apenas a uma agenda]"
    }
  },
  "ONBOARD": {
    "setupStoreSuccess": {
      "doneTitle": "Já está! 🎉",
      "guidanceTitle": "Boa! Agora só tem de partilhar o link da sua Página de Marcações com os seus clientes.",
      "viewPage": "Ver página",
      "copyLink": "Copiar link",
      "linkCopied": "Link copiado"
    },
    "step1Title": "Bem-vindo à sua agenda digital! 🎉",
    "step1Text": "Aqui é onde pode gerir as suas marcações. Aceda à sua agenda digital a qualquer hora e em qualquer lugar através do seu computador ou smartphone.",
    "step2Title": "Personalize a sua Página de Marcações",
    "step2Text": "Clique no seu link de marcações no menu principal e personalize a sua página à imagem do seu negócio.",
    "step3Title": "Partilhe o seu link com os seus clientes!",
    "step4Help1": "Precisa de ajuda?",
    "step4Title": "Agende uma demonstração com a nossa equipa!",
    "step4Text": "Caso tenha alguma dúvida sobre a sua agenda online, contacte-nos ou agende uma demonstração gratuita.",
    "step4Help2": "Whatsapp: 965 541 732 ou suporte@buk.pt",
    "btnContinue": "Continuar",
    "btnExplore": "Explorar agenda",
    "bookADemoBtn": "Agendar demonstração",
    "watchDemoBtn": "Ver demonstração"
  },
  "DASHBOARD": {
    "activate": "Activar",
    "deactivate": "Desactivar",
    "updateAvailable": "Atualização necessária, clique aqui.",
    "teyaSetupPage": {
      "companyData": "Dados da empresa",
      "companyDataDesc": "Usamos estes dados para preparar o contrato e a entrega do terminal Teya.",
      "contractData": "Dados para o contrato",
      "contractDataDesc": "Identificação da empresa e estimativa de volume em cartão.",
      "deliveryAddress": "Morada para entrega do terminal e cartões",
      "deliveryAddressDesc": "Para onde enviamos o terminal e, se aderir à Conta Teya Business, os cartões.",
      "companyName": "Nome da empresa",
      "companyNamePlaceholder": "Introduza o nome da empresa",
      "vatNumber": "NIF",
      "vatNumberPlaceholder": "Introduza o NIF",
      "phoneNumber": "Número de telefone",
      "phoneNumberPlaceholder": "Introduza o número de telefone",
      "email": "Email",
      "emailPlaceholder": "Introduza o email",
      "invoicingDesc": "Só pagamentos com cartão — não o total do salão. Sugerido a partir das vendas Buk (menos uma parte em numerário); altere se a realidade for outra.",
      "monthlyCardVolume": "Faturação mensal em cartão",
      "monthlyCardVolumePlaceholder": "Selecione a faturação mensal em cartão",
      "contractType": "Escolha a modalidade",
      "contractTypeDesc": "Selecione um plano de taxas e onde quer receber os pagamentos.",
      "cashback": "cashback",
      "noMonthlyFee": "Sem mensalidade",
      "perMonth": "/mês",
      "settlementIn": "Liquidação em",
      "teyaBusinessAccount": "Conta Teya Business",
      "teyaBusinessAccountInfoTitle": "O que é a Conta Teya Business?",
      "teyaBusinessAccountInfoDesc": "Ao receber os pagamentos numa Conta Teya Business, tem acesso a um cartão de débito com 0,5% de cashback em compras — que ajuda a compensar a mensalidade escolhida.",
      "ownBankAccount": "A sua conta bancária",
      "fewTransactionsDescription": "Compensa quem tem poucas transações: evita a mensalidade, pagando uma pequena taxa fixa por transação.",
      "manyTransactionsDescription": "Compensa quem tem muitas transações pequenas: a mensalidade dilui-se e o cashback ajuda a absorvê-la.",
      "ownBankDescription": "Para quem prefere manter o dinheiro na conta bancária habitual, sem o cashback da Teya Business.",
      "personalCredit": "Crédito particular",
      "businessOrInternational": "Empresarial ou internacional",
      "personalDebit": "Débito particular",
      "amexAndOtherCards": "AMEX e outros cartões",
      "yourPlan": "O seu plano:",
      "plans": {"simple": "Teya Simple","advanced": "Teya Advanced","premium": "Teya Premium","private": "Teya Private"},
      "perTransaction": "/tx",
      "terminalFee": "Terminal",
      "terminalCharged": "Cobrado",
      "terminalOffered": "Oferecido",
      "terminalHalfPrice": "50% de desconto",
      "terminalHalfPriceNote": "* 50% de desconto no terminal; oferta total sujeita a aprovação.",
      "selected": "Selecionado",
      "choose": "Escolher",
      "address": "Morada",
      "addressPlaceholder": "Introduza a morada",
      "postalCode": "Código postal",
      "postalCodePlaceholder": "Introduza o código postal",
      "city": "Cidade",
      "cityPlaceholder": "Introduza a cidade",
      "terminalType": "Escolha o seu terminal",
      "terminalTypeDesc": "Todos os terminais aceitam cartão, contactless e chegam configurados para o BUK.",
      "vatIncluded": "+ IVA",
      "printer": "Impressora",
      "chooseTerminal": "Escolher terminal",
      "terminalDescriptions": {
        "teya_pro": "Design elegante, bateria duradoura e impressora integrada.",
        "teya_go": "Leve, fiável e ideal para negócios em movimento.",
        "teya_lite": "O nosso terminal mais compacto, feito para balcões pequenos e negócios sempre em movimento."
      },
      "li1": "Integrado com o sistema de vendas do BUK.",
      "li2": "Zero erros de caixa: elimina divergências entre os relatórios do BUK e do terminal.",
      "li3": "Cobrança rápida: reduz o tempo de atendimento na caixa ao fechar a marcação.",
      "ctaBoxTitle": "Ainda não tem um terminal de pagamentos Teya?",
      "oauthTitle": "Iniciar sessão na Teya",
      "oauthDesc": "Depois do login, o BUK escolhe o terminal associado à sua conta — na maior parte dos casos há só um.",
      "oauthCta": "Iniciar sessão na Teya",
      "oauthConnectedTitle": "Conta Teya",
      "oauthConnectedDesc": "Sessão iniciada com sucesso",
      "cloudModeInstructions":  "Para ficar ligado ao BUK, o terminal tem de estar em <b>modo cloud</b>. No terminal: Menu → Integrações POS (no fundo do menu) → Comunicação na cloud → Sair do menu.",
      "disconnectCta": "Terminar sessão",
      "terminalsTitle": "Terminal",
      "terminalsDesc": "Escolha o terminal desta conta Teya a usar nas vendas do BUK.",
      "terminalLabel": "Terminal associado",
      "saveTerminalsBtn": "Guardar",
      "activateTeya": "Aderir à Teya",
      "sendRequest": "Enviar pedido",
      "requestSent": "Pedido enviado!",
      "requestSentDescription": "Recebemos o seu pedido de adesão à Teya. A nossa equipa vai analisá-lo e enviar uma proposta em breve.",
      "responseTime":  "Prazo habitual de resposta: até 48 horas.",
      "conclude": "Concluir",
      "awaitingProposal": "A aguardar uma proposta",
      "awaitingProposalDesc": "Recebemos o seu pedido de adesão. A nossa equipa irá contactá-lo em breve.",
      "monthlyCardVolumeOptions": {
        "under_2500": "Menos de 2 500 €",
        "2500_5000": "Entre 2 500 € e 5 000 €",
        "5000_10000": "Entre 5 000 € e 10 000 €",
        "10000_15000": "Entre 10 000 € e 15 000 €",
        "15000_30000": "Entre 15 000 € e 30 000 €",
        "30000_50000": "Entre 30 000 € e 50 000 €",
        "over_50000": "Mais de 50 000 €"
      },
      "settlementAccountOptions": {
        "teya_business": "Conta empresarial Teya",
        "own_bank": "Conta bancária própria"
      },
      "terminalOptions": {
        "teya_pro": "Teya Pro",
        "teya_go": "Teya Go",
        "teya_lite": "Teya Lite"
      }
    },
    "referralPage": {
      "title": "Convide os seus amigos <br/>e ganhe 100€",
      "subtitle": "Ofereça um desconto de 50% aos seus amigos e receba €50 em créditos de Marketing + €50 de crédito na sua subscrição.",
      "cta": "Convidar amigos",
      "ctaSubtitle": "Ganhe 100€ / convite",
      "viewReferrals": "As minhas referências",
      "viewRewards": "As minhas recompensas",
      "box1": "Partilhe o seu link de convite com os seus amigos ou nas redes sociais",
      "box2": "O seu amigo subscreve qualquer plano PRO do BUK com 50% de desconto durante 6 meses",
      "box3": "Você recebe 50€ em Marketing e 50€ para descontar na sua subscrição.",
      "title2": "Continue a convidar e a ganhar",
      "subtitle2": "Quanto mais partilhar mais ganha! Sem limite de convites.",
      "faqQ1": "Como posso aderir ao programa?",
      "faqA1": "Não precisa de aderir. Clique em 'Convidar amigos' e partilhe o seu link de convite.",
      "faqQ2": "Como sou recompensado?",
      "faqA2": "No dia em que o seu amigo pagar qualquer plano Pro, você recebe 50€ em créditos de marketing + 50€ de desconto no seu próximo pagamento de subscrição.",
      "faqQ3": "Quantos amigos posso convidar?",
      "faqA3": "Não há limite de convites. Quantos mais convidar mais probabilidade tem de ganhar!",
      "faqQ4": "Como sei se os meus amigos pagaram?",
      "faqA4": "Use a secção abaixo para acompanhar quantos dos seus amigos registraram o seu negócio e as suas recompensas.",
      "yourReferrals": "As suas referências",
      "yourRewards": "As suas recompensas",
      "registered": "Registrado",
      "added": "Adicionado",
      "inMarketing": "em Marketing",
      "inSubscriptionCredit": "em Crédito de Subscrição",
      "emptyReferrals": "Ainda não tem nenhuma referência",
      "emptyRewards": "Ainda não tem nenhuma recompensa"
    },
    "multipleServiceSettings": {
      "title": "Marcações de multiplos serviços",
      "description": "Com esta opção os seus clientes podem selecionar vários serviços na mesma marcação.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "config": "Configurar regras",
      "configDesc": "Defina uma ou mais regras para marcações de multiplos serviços"
    },
    "posSettings": {
      "title": "Módulo Moloni",
      "discontinued": "Descontinuado",
      "description": "Emita as suas faturas directamente a partir do BUK com a sua conta Moloni Flex ou Pro. Incluí 2 meses grátis na Moloni exlusivo para clientes BUK.",
      "link": "Saber mais",
      "activate": "Configurar",
      "deactivate": "Desactivar"
    },
    "salesSettings": {
      "title": "Gestão de Vendas",
      "description": "Controle o dinheiro que entra e sai todos os dias com a gestão de vendas.",
      "cta": "Configurar"
    },
    "invoicingSettings": {
      "title": "BUK Faturação",
      "description": "Emita faturas e faça a gestão da sua contabilidade directamente no BUK com o nosso modulo de faturação.",
      "cta": "Configurar"
    },
    "salesSetupPage": {
      "title": "Gestão de Vendas",
      "active": "Activo",
      "inactive": "Inactivo",
      "desc": "Controle o dinheiro que entra e sai todos os dias com o módulo de gestão de vendas.",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "help": "Ajuda",
      "boxTitle": "O que está incluído?",
      "li1": "Menu de gestão de vendas",
      "li2": "Registo de pagamentos e descontos",
      "li3": "Registo de dívidas de clientes",
      "li4": "Registo de comissões",
      "cancelTitle": "Atenção",
      "cancelDescription": "Ao desativar o módulo de vendas vai perder acesso a funcionalidades que podem ser críticas para o seu negócio, como Gestão de pagamentos, Estatísticas de Vendas e Comissões.",
      "continue": "Continuar",
      "tutorialTitle0": "Módulo de Vendas ativado!",
      "tutorialDescription0": "Agora pode gerir as suas vendas dentro do BUK, clique continuar para saber mais.",
      "tutorialTitle1": "Menu Gestão de Vendas",
      "tutorialDescription1": "Aceda ao novo menu de Vendas através da navegação principal, aqui pode ver todos os registos de vendas, pagamentos e comissões.",
      "tutorialTitle2": "Gestão de Vendas",
      "tutorialDescription2": "Registe as suas vendas em segundos, com um processo simples e intuitivo. Adicione descontos e escolha um ou mais métodos de pagamento.",
      "tutorialTitle3": "Comissões",
      "tutorialDescription3": "Configure as comissões dos seus colaboradores, e consulte os relatórios no menu de Vendas.",
      "tutorialTitle4": "Módulo de Faturação BUK",
      "tutorialDescription4": "Agora também pode emitir faturas diretamente no BUK com o nosso módulo de faturação integrado.",
      "managePermissions": "Permissões",
      "permissionsModal": {
        "title": "Permissões de vendas",
        "subtitle": "Defina quem pode ver, editar ou eliminar dados de vendas nesta loja.",
        "columnUser": "Utilizador",
        "columnView": "Ver",
        "columnEdit": "Editar",
        "columnDelete": "Eliminar",
        "adminFootnote": "Os administradores têm sempre acesso total às vendas; as caixas para estes perfis são apenas informativas.",
        "save": "Guardar",
        "cancel": "Cancelar",
        "close": "Fechar",
        "loading": "A carregar utilizadores…",
        "loadError": "Não foi possível carregar a lista de utilizadores."
      },
      "invoiceActiveTitle": "Precisa do módulo de vendas ativo",
      "invoiceActiveDescription": "Para desativar o módulo de vendas, tem primeiro de desativar o módulo de faturação.",
      "goToInvoicing": "Saber mais sobre faturação"
    },
    "invoicingSetupPage": {
      "title": "BUK Faturação",
      "active": "Activo",
      "inactive": "Inactivo",
      "desc": "Emita faturas de forma automática e organizada, sem complicações. Tenha sempre o controlo das suas vendas e pagamentos num só lugar.",
      "askForAccess": "Pedir acesso",
      "certificate": "Certificado pela Autoridade Tributária Nº2578."
    },
    "invoicingOnboardSetupPage": {
      "setupHeader": "Para aceder o módulo de faturação, precisamos apenas que nos envie alguns dados",
      "merchantName": "Nome de Registo",
      "vatNumber": "NIF da entidade",
      "emailAddress": "Email",
      "address": "Morada",
      "city": "Localidade",
      "postalCode": "Código postal",
      "postalCodeInvalid": "O código postal deve estar no formato XXXX-XXX",
      "sendRequest": "Enviar pedido",
      "askForHelp": "Falar connosco"
    },
    "storeSettingsPage": {
      "businessName": "Nome",
      "invalidBusinessName": "Por favor introduza o nome do seu estabelecimento.",
      "phone": "Telemóvel",
      "phonePlaceholder": "Número de Telemóvel",
      "invalidPhone": "Por favor introduza o seu número de Telemóvel",
      "addressPlaceholder": "Escreva a sua morada",
      "address": "Morada",
      "invalidAddress": "Por favor introduza a morada",
      "allowBookingsOnlyBefore": "Não permitir aos clientes marcações na(s) próxima(s):",
      "maxDaysInAdvance": "Não permitir aos clientes marcações após:",
      "allowBookingsOnlyBeforeEx": "Ex. Um cliente não poderá agendar um serviço para daqui a 30m (se tiver 1h configurada)",
      "maxDaysInAdvanceEx": "Ex. Um cliente não poderá agendar um serviço para daqui a 13 meses (se tiver 12 meses configurado)",
      "calendarIntervals": "Intervalos de tempo do calendário",
      "notificationAdvanceTime": "Antecedência de lembrete por E-mail e SMS",
      "notificationAdvanceTimeNoSMS": "Antecedência de lembrete por E-mail",
      "timezone": "Fuso horário:",
      "slug": "Link",
      "invalidSlug": "Por favor escreva como quer o seu Link",
      "deleteStoreSure": "Tem a certeza que deseja apagar \"{{insert}}\"? Atenção: Esta acção não tem forma de ser recuperada.",
      "pageTitle": "Definições gerais",
      "basicStoreTitle": "Informações básicas",
      "basicStoreDesc": "Mantenha as informações do seu<br/> negócio actualizadas",
      "configStoreTitle": "Agenda & Página de marcações",
      "configStoreDesc": "Configure e adapte a sua agenda à realidade do seu negócio",
      "notesOnEvents": "Mostrar observações no calendário",
      "notesOnEventsNo": "Não",
      "notesOnEventsYes": "Sim",
      "hideProvidersOutOfOffice": "Ocultar colaboradores de folga",
      "hideProvidersOutOfOfficeNo": "Não",
      "hideProvidersOutOfOfficeYes": "Sim",
      "customFieldsTitle": "Campos personalizados",
      "customFieldsDescription": "Personalize as informações das fichas de clientes e da página de marcações",
      "customFieldsConfig": "Configurar",
      "customFieldsEmptyState": "Não tem campos personalizados.",
      "optimizeOnlineBookings": "Optimizar agendamentos",
      "optimizeOnlineBookingsDescription": "Reduza os buracos na sua agenda e melhore a ocupação ao definir os horários que os clientes podem reservar online",
      "minimizeHolesOnCalendarNo": "Intervalos de tempo regulares",
      "minimizeHolesOnCalendarNoDescription": "Mostre todos os horários disponíveis com base no intervalo definido em cima. Isto pode criar lacunas na sua agenda",
      "minimizeHolesOnCalendarYes": "Reduzir buracos na agenda",
      "minimizeHolesOnCalendarYesDescription": "Apresente de forma inteligente mais horários disponíveis aos seus clientes, evitando a criação de buracos na agenda difíceis de preencher"
    },
    "storeMessagingPage": {
      "pageDisclaimer": "Estas são as mensagens que são enviadas automaticamente para os seus clientes quando cria uma marcação, edita, cancela e na véspera.",
      "guidanceTitleConfirm": "Marcação Confirmada",
      "confirmEmail": "Olá <strong>%NOME%</strong>, <br/>A sua marcação para <strong>%NOME_NEGOCIO%</strong> foi confirmada. <br/><br/>Data da marcação: <strong>%DATA%</strong> <br/><br/>{{insert}} Se desejar cancelar esta marcação basta clicar na seguinte ligação <strong>%LINK_CANCELAR%</strong> ou ligue para <strong>%TELEFONE%</strong> <br/><br/>Obrigado",
      "guidanceTitleEdited": "Marcação Alterada",
      "editedEmail": "Olá <strong>%NOME%</strong>,<br/>A sua marcação (<strong>%NOME_NEGOCIO%</strong>) foi alterada para <strong>%DATA%</strong>.<br/><br/>{{insert}}Se desejar cancelar esta marcação basta clicar na seguinte ligação <strong>%LINK_CANCELAR%</strong> ou ligue para <strong>%TELEFONE%</strong> <br/><br/>Obrigado",
      "guidanceTitleCanceled": "Marcação Cancelada",
      "canceledEmail": "Olá <strong>%NOME%</strong>,<br/>A sua marcação para <strong>%NOME_NEGOCIO%</strong> em <strong>%DATA%</strong> foi cancelada.<br/><br/>{{insert}} Contacte-nos aqui <strong>%TELEFONE%</strong> para mais informações.<br/><br/>Obrigado",
      "guidanceTitleReminder": "Lembrete de marcação",
      "reminderEmail": "Olá <strong>%NOME%</strong>,<br/> Relembramos que tem uma marcação <strong>%DATA%</strong> para <strong>%NOME_NEGOCIO%</strong><br/><br/>{{insert}} Se desejar cancelar esta marcação basta clicar na seguinte ligação <strong>%LINK_CANCELAR%</strong> ou ligue para <strong>%TELEFONE%</strong> <br/><br/>Obrigado",
      "emailTitle": "Email",
      "smsTitle": "SMS",
      "smsGuidance": "Precisa de activar um plano pago para os seu clientes receberem SMS's",
      "editedSMS": "A sua marcação foi alterada para %DATA% %NOME_NEGOCIO%. Se desejar cancelar siga esta ligação %LINK_CANCELAR% ou ligue %TELEFONE%",
      "canceledSMS": "A sua marcação para %DATA% %NOME_NEGOCIO% foi cancelada. Contacte-nos aqui %TELEFONE% para mais informações",
      "reminderSMS": "Relembramos que tem uma marcação %DATA% (%NOME_NEGOCIO% - %TELEFONE%)",
      "importantInformation": "Informações importantes:",
      "importantInformationHelper": "Opcionalmente pode adicionar informações extra no email:",
      "guidanceSenderSMS": "Remetente SMS",
      "invalidChangeBookingSMS": "Campo obrigatório: indique uma mensagem para Marcação Alterada (máx: 160 caracteres)",
      "invalidCanceledBookingSMS": "Campo obrigatório: indique uma mensagem para Marcação Cancelada (máx: 160 caracteres)",
      "invalidReminderSMS": "Campo obrigatório: indique uma mensagem para Lembrete de Marcação (máx: 160 caracteres)",
      "resetText": "Repor texto original",
      "invalidSenderSMS": "Campo obrigatório: indique o remetente (máx: 11 caracteres)",
      "senderStatusApproved": "Aprovado",
      "senderStatusPending": "Aguarda aprovação",
      "senderStatusRejected": "Rejeitado",
      "senderStatusFallbackNote": "Enquanto este remetente não estiver aprovado, os SMS serão enviados com o remetente \"BUK\".",
      "senderStatusRejectedNote": "Este nome de remetente foi rejeitado. Tente com um novo nome. Entretanto, os SMS serão enviados com o remetente \"BUK\".",
      "customSmsTitle1": "Personalize o texto dos seus SMS em baixo",
      "customSmsTitle2": "Use estes campos especiais para personalizar os seus SMS",
      "fieldsDate": "para data da marcação em formato relativo (ex: Quinta-feira, 1 de Janeiro 09:30)",
      "fieldsDateFull": "para data da marcação em formato completo (ex: 01/01/2026 09:30)",
      "fieldsStoreName": "para nome da loja",
      "fieldsStoreContact": "para contacto da loja",
      "fieldsProviderName": "para o nome do colaborador",
      "fieldsServiceName": "para o nome do serviço",
      "fieldsCancelLink": "para link de cancelamento da marcação",
      "fieldClientName": "para o nome do cliente",
      "dateField": "%DATA%",
      "dateFullField": "%DATA_NUM%",
      "storeNameField": "%NOME_NEGOCIO%",
      "clientNameField": "%NOME_CLIENTE%",
      "providerNameField": "%COLABORADOR%",
      "serviceNameField": "%SERVICO%",
      "phoneField": "%TELEFONE%",
      "cancelLinkField": "%LINK_CANCELAR%",
      "birthdaySMS": "SMS de Aniversário",
      "birthdaySmsSetting": "Enviar SMS de aniversário para os clientes",
      "birthdayMessage": "Neste dia tão especial desejamos-lhe muitos parabéns e um excelente aniversário em nome de toda a equipa %NOME_NEGOCIO%",
      "invalidClientBirthdayMessage": "Campo obrigatório: indique uma mensagem para SMS de Aniversário (máx: 160 caracteres)",
      "senderStatusUnsaved": "Para submeter o seu remetente, clique em \"Gravar\" no fundo da página.",
      "nameInstructions": "Leia as nossas dicas para escolher um nome de remetente",
      "namingInstructionsTitle": "Remetente SMS",
      "namingInstructionsDescription": "Em alguns casos, os operadores de telecomunicações, como MEO, Vodafone, NOS, entre outros, bem como os próprios telemóveis, podem classificar automaticamente algumas mensagens como spam.<br/><br/>Infelizmente, esta filtragem é feita pelos operadores ou pelos sistemas dos próprios dispositivos, pelo que não temos controlo direto sobre essa decisão.<br/><br/>Temos verificado que, tanto em Portugal como noutros países, os operadores têm vindo a tornar os filtros de SMS mais rigorosos, com o objetivo de reduzir o aumento de spam e mensagens fraudulentas.<br/><br/>Quando o remetente da SMS é um nome pessoal ou demasiado genérico, em vez do nome do negócio, existe uma maior probabilidade de a mensagem ser filtrada ou sinalizada como spam.<br/><br/>Se estiver a ter problemas com a entrega das SMS, recomendamos alterar o nome do remetente para algo mais identificável e associado ao negócio. Em alternativa, pode também experimentar utilizar \"BUK\" como remetente."
    },
    "calendarPage": {
      "today": "HOJE",
      "block": "Bloquear Horário",
      "book": "Nova Marcação",
      "newInvoice": "Novo Pagamento",
      "teyaSoloPay": "Novo Pagamento",
      "week": "Semana",
      "threeDay": "3 dias",
      "blocked": "BLOQUEADO",
      "day": "Dia",
      "providerSelected": "Preferência por colaborador",
      "invoiceExists": "Venda emitida",
      "paid": "Pago online",
      "noCalendars": "Dia sem agendas activas",
      "isLoyaltyPrizeBooking": "Prémio de Fidelização",
      "defaultName": "Exemplo",
      "add": "Adicionar",
      "providers": "Equipa",
      "roomEquipment": "Sala / Equipamento",
      "roomEquipmentShort": "Sala/Equip.",
      "roomOccupied": "OCUPADO"
    },
    "storeSettingsMenu": {
      "services": "Serviços",
      "products": "Produtos",
      "providers": "Equipa",
      "workplan": "Horários",
      "notifications": "Notificações",
      "users": "Utilizadores",
      "rooms": "Salas"
    },
    "workplanOverride": {
      "title": "Horários para dias especiais",
      "description": "Configure horários para dias especiais.",
      "upcomingExceptions": "Próximos horários",
      "newException": "Novo horário",
      "noExceptions": "Ainda não tem horários configurados.",
      "collaboratorsText": "colaborador(es)",
      "chooseDay": "Escolha um dia",
      "invalidDate": "Por favor selecione uma data válida",
      "dateRequired": "Por favor selecione uma data",
      "timeSlots": "Horários",
      "chooseProviders": "Escolha os colaboradores",
      "atLeastOneProviderRequired": "Por favor selecione pelo menos um colaborador"
    },
    "clientSettingsMenu": {
      "clients": "Clientes",
      "blacklist": "Bloqueados"
    },
    "selectProvider": {
      "generalView": "Visão Geral",
      "newResource": "Novo Colaborador"
    },
    "newClientForm": {
      "addClient": "Adicionar Cliente",
      "name": "Nome",
      "namePlaceholder": "Primeiro e último nome",
      "invalidName": "Por favor indique o nome do cliente",
      "email": "E-mail",
      "emailPlaceholder": "E-mail",
      "invalidEmail": "Por favor indique o e-mail do cliente",
      "vatNumber": "NIF",
      "vatNumberPlaceholder": "NIF",
      "invalidvatNumber": "Por favor indique o NIF do cliente",
      "phone": "Telefone",
      "invalidNumber": "Número inválido",
      "notifyClient": "Enviar e-mail com o link para a sua Página de Marcações",
      "notes": "Observações",
      "notesPlaceholder": "Observações",
      "notifications": "Campanhas e-mail e SMS",
      "subscribed": "Aceita receber",
      "unsubscribed": "Não aceita receber"
    },
    "newClientBlacklistForm": {
      "addClient": "Bloquear Cliente",
      "name": "Nome",
      "namePlaceholder": "Primeiro e último nome",
      "invalidName": "Por favor indique o seu nome",
      "email": "E-mail",
      "emailPlaceholder": "E-mail",
      "invalidEmail": "Por favor indique o seu e-mail",
      "phone": "Telefone",
      "invalidNumber": "Número inválido"
    },
    "clientsPage": {
      "search": "Procurar nome, email ou número",
      "create": "Novo",
      "newClient": "Novo cliente",
      "emptyStateH3": "Ainda não tem clientes no sistema",
      "emptyStateP": "Adicione clientes ou partilhe a sua Página de Marcações e comece a receber os seus primeiros clientes.",
      "emptyStateH3Blacklist": "Ainda não tem clientes bloqueados",
      "contactImportTitle": "Importe a sua lista de clientes",
      "contactImport": "Para importar a sua lista de clientes, contacte-nos em: ",
      "tableHeaders": {
        "name": "Nome",
        "email": "Email",
        "phoneNumber": "Telefone",
        "bookings": "Marcações",
        "lastVisit": "Última visita"
      },
      "filters": {
        "name": "Nome Az",
        "bookingsAsc": "Mais marcações",
        "bookingsDesc": "Menos marcações",
        "lastVisitAsc": "Visitas recentes",
        "lastVisitDesc": "Visitas antigas"
      },
      "newCampaign": "Enviar campanha",
      "inactiveClientsTitle": "Chame os seus clientes inactivos de volta!",
      "inactiveClientsDesc": "Ofereça um desconto e promova os seus serviços com uma campanha SMS",
      "activeClientsTitle": "Comunique com os seus clientes",
      "activeClientsDesc": "Envie uma campanha SMS através do nosso sistema de Marketing",
      "noContacts": "Nenhum contato adicionado",
      "importingDescription": "Estamos a importar os seus clientes, este processo pode demorar até 24h",
      "importButton": "Importar",
      "exportButton": "Exportar",
      "importExportButton": "Importar / Exportar"
    },
    "importClients": {
      "title": "Importar clientes",
      "subtitle": "Faça upload da sua lista de clientes",
      "importButton": "Importar",
      "uploadFile": "Upload de ficheiro",
      "uploadFileDescription": "Formatos: .xls, .csv ou .vcf",
      "importExportTitle": "Importar / Exportar Clientes",
      "importExportSubtitle": "Importe novos clientes ou exporte a sua lista de clientes existente",
      "importMode": "Importar",
      "exportMode": "Exportar",
      "exportTitle": "Exportar Clientes",
      "exportDescription": "Exportar {{count}} clientes em formato Excel",
      "exportButton": "Exportar",
      "exportNoClients": "Não tem clientes para exportar",
      "csvExport": {
        "name": "Nome",
        "email": "E-mail",
        "phoneNumber": "Número de telefone",
        "notes": "Observações",
        "subscribed": "Aceita comunicações de marketing?",
        "vatNumber": "NIF",
        "bookings": "Número de Marcações",
        "lastVisit": "Última Visita"
      }
    },
    "clientForm": {
      "personalInfo": "Informação Pessoal",
      "general": "Visão geral",
      "name": "Nome",
      "namePlaceholder": "Primeiro e último nome",
      "nameInvalid": "Por favor indique o nome do cliente",
      "email": "E-mail",
      "emailPlaceholder": "E-mail",
      "emailInvalid": "Por favor indique o e-mail do cliente",
      "vatNumber": "NIF",
      "vatNumberPlaceholder": "NIF",
      "vatNumberInvalid": "Por favor indique o NIF do cliente",
      "phone": "Telefone",
      "phoneInvalid": "Número inválido",
      "deleteClient": "Apagar Cliente",
      "bookings": "Marcações",
      "emptyBookings": "Este cliente não tem marcações...",
      "addToBlacklist": "Bloquear",
      "removeFromBlacklist": "Desbloquear",
      "notes": "Observações",
      "notesPlaceholder": "Observações",
      "subscribed": "O cliente deseja receber campanhas por e-mail e SMS",
      "dob": "Data de nascimento",
      "stats": "Estatísticas",
      "history": "Histórico",
      "seeMore": "Ver mais ▾",
      "loadMore": "Carregar mais",
      "nextBookings": "Próximas marcações",
      "complete": "Completas",
      "canceled": "Canceladas",
      "noshow": "Faltas",
      "totalValue": "Valor total",
      "lastVisitHeader": "Última visita há",
      "activeClient": "Cliente activo",
      "inactiveClient": "Cliente inactivo",
      "newClient": "Novo cliente",
      "options": "Opções",
      "editClient": "Editar",
      "canceledBy": "Cancelada por",
      "createdBy": "Criada por",
      "client": "cliente",
      "canceledByCustomer": "Cancelada por cliente",
      "source": "Origem",
      "gender": "Género",
      "customFields": "Campos Personalizados",
      "whatsapp": "Enviar WhatsApp",
      "sales": "Vendas",
      "files": "Ficheiros"
    },
    "clientAttachments": {
      "upload": "Escolher ficheiros",
      "drag": "Upload de ficheiro",
      "fileTypeSize": "PDF, JPG, PNG, DOCX, etc (Máx. {{max}}MB)",
      "noAttachments": "Não existem anexos.",
      "document": "Documento",
      "fileTooLarge": "Ficheiro demasiado grande. Tamanho máximo {{max}}MB."
    },
    "documentPreviewModal": {
      "cannotPreview": "Não é possível pré-visualizar este tipo de ficheiro.",
      "downloadToView": "Faça o download para visualizar",
      "download": "Download",
      "downloadAttachment": "Download",
      "deleteAttachment": "Apagar",
      "deleteAttachmentTitle": "Tem a certeza que deseja apagar este anexo?"
    },
    "statsPage": {},
    "userForm": {
      "createUser": "Criar novo utilizador",
      "editUser": "Editar utilizador",
      "name": "Nome",
      "namePlaceholder": "Nome",
      "invalidName": "Nome inválido",
      "email": "Email",
      "emailPlaceholder": "Email",
      "invalidEmail": "Email inválido",
      "roleLabel": "Perfil de Acesso",
      "rolePlaceholder": "Perfil de Acesso",
      "roleInvalidMessage": "Perfil de Acesso inválido",
      "createUserButton": "Criar utilizador",
      "editUserButton": "Guardar",
      "deleteUser": "Apagar",
      "resendInvitation": "Reenviar email de convite",
      "inviteLinkLabel": "Link para definir a password",
      "inviteLinkLoading": "A carregar link...",
      "instructions": "Um convite será enviado para este endereço de email.",
      "salesPermissions": "Permissões de Vendas",
      "canCreateEditSales": "Pode criar e editar vendas",
      "canViewSales": "Pode visualizar vendas",
      "canDeleteSales": "Pode apagar vendas"
    },
    "setupStoreUsers": {
      "guidanceTitle": "Faça a gestão dos acessos",
      "activeUser": "Activo",
      "inactiveUser": "Inactivo",
      "addNew": "Adicionar novo"
    },
    "stripeSettings": {
      "title": "Pagamentos Online (Stripe)",
      "description": "Cartão de crédito, Apple Pay, Google Pay.",
      "configure": "Configurar",
      "mandatoryPayments": "Activar Pagamento obrigatório",
      "optionalPayments": "Desactivar Pagamento obrigatório",
      "mandatoryPaymentsAreDeactived": "O pagamento não é obrigatório para fazer uma marcação.",
      "mandatoryPaymentsAreActived": "O pagamento é obrigatório para fazer uma marcação."
    },
    "paymentSettings": {
      "title": "Pagamentos Online",
      "description": "Disponibilize o pré-pagamento com MBWay, Cartão de crédito, Apple/Google Pay (Comissão 1.9% + 0.50€).",
      "configure": "Configurar"
    },
    "accountSettingsMenu": {
      "account": "A minha conta",
      "subscription": "Subscrição",
      "invoices": "Faturas",
      "invoicesText": "As suas faturas ficam disponíveis no início do dia seguinte"
    },
    "tutorialBanner": {
      "tip1": "Como fazer uma marcação",
      "tip2": "Menus e funcionalidades da agenda",
      "tip3": "Como personalizar a sua página de marcações",
      "watchPlaylist": "Ver vídeos"
    },
    "embedCodeSetup": {
      "wordpress1": "Se o seu website for desenvolvido em Wordpress",
      "wordpress2": "consulte aqui o nosso plugin",
      "copyCode": "Copiar código",
      "copyCodeSuccess": "Código copiado"
    },
    "setupCustomFields": {
      "text": "Texto",
      "date": "Data",
      "dropdown": "Várias Opções",
      "optional": "Opcional",
      "public": "Público",
      "private": "Privado",
      "addNew": "Adicionar novo",
      "editCreateServices": "Editar campo personalizado",
      "name": "Nome do campo",
      "invalidName": "Nome inválido",
      "type": "Tipo de campo",
      "invalidType": "Tipo inválido",
      "showOnBookingPage": "Campo público",
      "showOnBookingPageDesc": "Visivel na sua página de marcações",
      "mandatoryShort": "Obrigatório",
      "mandatory": "Preenchimento obrigatório",
      "mandatoryDesc": "Para clientes (marcações online)",
      "confirmDeleteField": "Tem a certeza que deseja apagar este campo personalizado?",
      "dropdownValues": "Opções (uma opção por linha)",
      "invalidDropdownValues": "Opções inválidas",
      "alertMsg1": "Não adicione aqui os campos NIF, Data de Nascimento e Género.",
      "alertMsg2": "Pode adiciona-los em \"Mais opções\" da sua página de marcações,",
      "alertMsg3": "clique aqui."
    },
    "marketingModal": {
      "no": "Não, obrigado",
      "usePromo": "Usar promoção"
    }
  },
  "GENERAL": {
    "here": "aqui",
    "invalidValue": "Valor inválido",
    "downloading": "A descarregar...",
    "download": "Download",
    "filters": "Filtros",
    "all": "Todos",
    "salesExport": "vendas",
    "pay": "Pagar",
    "paid": "Pago",
    "invoice": "Fatura",
    "receipt": "Recibo",
    "creditNote": "Nota de crédito",
    "step": "Passo",
    "of": "de",
    "options": "Opções",
    "date": "Data",
    "state": "Estado",
    "generalErrorMsg": "Algo correu mal. Por favor, tente novamente.",
    "chooseOption": "Escolha uma opção",
    "error": "Algo correu mal. Por favor, tente novamente.",
    "retry": "Tentar novamente",
    "email": "E-mail",
    "phone": "Telefone",
    "invalidEmail": "Email Inválido",
    "password": "Password",
    "continue": "Continuar",
    "requiredField": "Campo obrigatório",
    "with": "com",
    "total": "Total",
    "signupCta": "Registar Grátis",
    "services": "Serviços",
    "schedule": "Horários",
    "resource": "Colaborador",
    "resources": "Colaboradores",
    "price": "Preço",
    "remove": "Apagar",
    "upload": "Upload",
    "save": "Gravar",
    "saveDraft": "Guardar rascunho",
    "updateDraft": "Atualizar rascunho",
    "cancel": "Cancelar",
    "configure": "Configurar",
    "savedSuccessfully": "Gravado com sucesso!",
    "deletedSuccessfully": "Apagado com sucesso!",
    "changesNotSaved": "As alterações não foram gravadas.",
    "edit": "Editar",
    "editServices": "Editar serviços",
    "fileTypeNotSupported": "Ficheiro não suportado",
    "storeTypes": {
      "agenda": "Agenda",
      "store": "Loja",
      "salon": "Salão",
      "center": "Centro",
      "clinic": "Clínica",
      "office": "Escritório",
      "agency": "Agência",
      "local": "Local"
    },
    "merchantTypes": {
      "optical": "Centro de Óptica",
      "psychology": "Psicologia",
      "nutricionist": "Nutricionista",
      "hairsalon": "Cabeleireiro",
      "barber": "Barbeiro",
      "beautySalon": "Salão de Beleza",
      "spaMassages": "Spa/Massagens",
      "personalTrainer": "Personal Trainer",
      "physiotherapy": "Fisioterapia",
      "dentist": "Clínica/Dentista",
      "veterinarian": "Clínica Veterinária",
      "petService": "Cuidados animais",
      "photography": "Fotografia",
      "realEstate": "Imobiliário",
      "consultancy": "Consultadoria",
      "advocacy": "Escritório de advocacia",
      "tutorMentor": "Tutor/Mentor",
      "sports": "Desporto",
      "other": "Outro",
      "nailsArtists": "Nails",
      "makeupArtists": "Makeup",
      "lashesArtists": "Lashes",
      "osteopath": "Osteopatia",
      "clinic": "Clínica",
      "aesthetic": "Estética",
      "holisticTeraphy": "Terapias holísticas",
      "tattooArtists": "Tattoos",
      "pharmacy": "Farmácia",
      "fitness": "Fitness",
      "auto": "Automóveis"
    },
    "new": "Novo",
    "no": "Não",
    "yes": "Sim",
    "month": "mês",
    "months": "meses",
    "week": "semana",
    "weeks": "semanas",
    "year": "ano",
    "areYouSure": "Tem a certeza?",
    "cookieConsent": "Este site utiliza cookies para melhorar a experiência do utilizador e analisar o tráfego do website. Por estas razões, podemos partilhar os seus dados de utilização com os nossos parceiros analíticos e redes sociais. Ao clicar em \"Aceitar Cookies\", autoriza o armazenamento no seu dispositivo das tecnologias descritas na nossa",
    "cookieConsentBtn": "Aceitar Cookies",
    "back": "Voltar",
    "close": "Fechar",
    "gender": {
      "male": "Masculino",
      "female": "Feminino",
      "other": "Outro"
    },
    "validators": {
      "invalidPortugueseVat": "NIPC/NIF inválido para Portugal (para números internacionais, use o código do país, ex: FR12345678901)",
      "invalidSpanishVat": "NIF inválido para Espanha. Para números internacionais, use o código do país, ex: FR12345678901)"
    },
    "advancedOptions": "Opções avançadas",
    "walkInCustomer": "Consumidor final"
  },
  "MARKETING": {
    "newCampaign": "Nova Campanha",
    "campaigns": "Campanhas",
    "processing": "A processar",
    "sent": "Enviado",
    "client": "cliente",
    "clients": "clientes",
    "content": "Conteúdo",
    "editContent": "Editar conteúdo",
    "pageTitleSms": "Campanha SMS",
    "campaignType": "Tipo de campanha",
    "pageTitleEmail": "Campanha e-mail",
    "storesPlaceholder": "Todas as Lojas",
    "titleLabel": "Nome da Campanha",
    "titlePlaceholder": "Nome da Campanha",
    "titleError": "Nome inválido",
    "fromEmail": "De",
    "fromEmailPlaceholder": "Nome do remetente",
    "fromEmailError": "Remetente inválido",
    "subjectLabel": "Assunto",
    "subjectPlaceholder": "Assunto da mensagem",
    "subjectError": "Assunto inválido",
    "senderLabel": "De",
    "senderPlaceholder": "De",
    "senderError": "Remetente inválido. Deverá conter no máximo 11 carácteres sem espaços, números e símbolos.",
    "templateTitle": "Título",
    "templateText": "Texto",
    "templateShowCover": "Mostrar imagem de cabeçalho",
    "templateShowCTA": "Mostrar botão CTA",
    "templateCtaText": "Texto do botão",
    "templateCtaLink": "Link do botão",
    "templateLabel": "Mensagem",
    "templatePlaceholder": "Escreva o conteúdo da sua mensagem",
    "templateError": "Mensagem inválida",
    "characters": "Caracteres",
    "test": "Enviar Teste",
    "sendCampaign": "Enviar campanha",
    "send": "Enviar",
    "presets": {
      "allTitle": "Todos os clientes",
      "allSubTitle": "Toda a lista de clientes",
      "activeTitle": "Clientes activos",
      "activeSubTitle": "Clientes com marcações nos últimos {{months}} meses",
      "activeSubTitle2": "Clientes com marcações",
      "activeSubTitle3": "Clientes com marcações nos últimos",
      "newTitle": "Novos clientes",
      "newSubTitle": "Clientes que fizeram a primeira marcação nos ultimos 30 dias",
      "oldTitle": "Clientes inactivos",
      "oldSubTitle": "Clientes sem marcações nos últimos {{months}} meses",
      "oldSubTitle2": "Clientes sem marcações",
      "oldSubTitle3": "Clientes sem marcações nos últimos"
    },
    "testSent": "Teste enviado com sucesso",
    "exclude": "Excluir",
    "excludeContact": "Excluir contacto",
    "excludeContactConfirm1": "Pretende excluir",
    "excludeContactConfirm2": "apenas desta campanha ou também de futuras comunicações?",
    "excludeContactBtnThis": "Apenas desta campanha",
    "excludeContactBtnAll": "Desta campanha e de futuras",
    "contactImport": "Quer importar a sua lista de clientes? <br/> Envie-nos um email para ",
    "sendDate": "Data de envio",
    "campaignCost": "Custo da campanha",
    "errorNoClients": "Tem de escolher um grupo de clientes primeiro",
    "marketingConsentInfo": "Apenas os clientes que aceitam receber campanhas de marketing são mostrados nesta lista.",
    "defaultSubject": "Assunto do email",
    "defaultTitle": "Título da campanha",
    "defaultCtaCopy": "Marque agora",
    "defaultText": "Texto da sua campanha...",
    "defaultSms": "A sua mensagem...",
    "tableCampaign": "Campanha",
    "tableSent": "Envios",
    "tableDate": "Data de Envio",
    "tableROI": "Retorno",
    "tableBookings": "marcações",
    "tableBooking": "marcação",
    "tableCost": "Custo",
    "tableStatus": "Estado",
    "subtitle": "Envie novidades ou promoções para todos os seus clientes",
    "balanceBanner": "Aproveite {{balance}}€ de desconto na sua próxima campanha",
    "senderStatusApproved": "Aprovado",
    "senderStatusPending": "Aguarda aprovação",
    "senderStatusRejected": "Rejeitado",
    "senderStatusFallbackNote": "Enquanto não estiver aprovado, os SMS serão enviados com o remetente \"BUK\". Pode alterar nas",
    "senderStatusApprovedNote": "Pode alterar nas",
    "senderStatusRejectedNote": "Este nome de remetente foi rejeitado. Tente com um novo nome. Entretanto, os SMS serão enviados com o remetente \"BUK\". Pode alterar nas",
    "senderStatusLink": "definições de notificações",
    "senderFreePlanNote": "Faça upgrade para o plano Pro para personalizar o remetente dos seus SMS.",
    "senderFreePlanGeneric": "BUK",
    "chooseTemplate": "Escolha um dos nossos templates",
    "newSuggestion": "Nova sugestão",
    "confirmModal": {
      "title": "Enviar campanha",
      "clients": "Clientes",
      "price": "Preço",
      "priceMin": "Preço mínimo de envio",
      "priceCredit": "Crédito {{balance}}€ aplicado!",
      "choosePayment": "Escolha um método de pagamento",
      "btnCard": "Cartão",
      "btnMbway": "MBWay",
      "btnMbwayMsg": "Irá receber uma notificação na app MBWay para efectuar o pagamento de ",
      "changeCard": "Alterar cartão",
      "useSelectedCard": "Usar cartão predefinido",
      "stateMbwayTitle": "Valide o pagamento no MBWay",
      "stateMbwayText": "Pedido enviado para:",
      "stateSendingTitle": "A preparar o envio...",
      "stateSendingText": "Aguarde um momento por favor",
      "stateSuccessTitle": "Campanha enviada!",
      "stateSuccessText": "Os seus clientes irão receber a sua campanha nos próximos minutos.",
      "stateSuccessBtn": "Voltar para marketing",
      "cancel": "Cancelar",
      "sendNow": "Enviar agora"
    }
  },
  "CONFIRM_DRAG": {
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "change_booking": "Alterar marcação",
    "change_holiday": "Alterar bloqueio",
    "before": "Anteriormente",
    "now": "Agora",
    "notify_client": "Notificar cliente"
  },
  "ACCOUNT": {
    "hi": "Olá",
    "basic_info": "Informações basicas",
    "first_last_name": "Primeiro e úiltimo nome",
    "email": "E-mail",
    "password": "Password",
    "current_password": "Password actual",
    "new_password": "Nova password",
    "account_notifications": "Notificações de conta",
    "new_booking": "E-mail de nova marcação",
    "new_booking_desc": "Sempre que tiver uma nova marcação",
    "notify_only_provider": "Receber notificações de:",
    "notify_only_provider_desc": "Receber emails e notificações só das marcações deste colaborador",
    "notify_all_providers": "Todos os colaboradores",
    "payment_confirmation": "E-mail de pagamento confirmado",
    "payment_confirmation_desc": "Quando um cliente conclui o pagamento de uma marcação criada pelo backoffice",
    "push_new_booking": "Notificação de nova marcação",
    "push_new_booking_desc": "Sempre que tiver uma nova marcação",
    "canceled_booking": "E-mail de marcação cancelada",
    "canceled_booking_desc": "Sempre que um cliente cancelar uma marcação",
    "push_canceled_booking": "Notificação de marcação cancelada",
    "push_canceled_booking_desc": "Sempre que um cliente cancelar uma marcação",
    "otherOptions": "Outras opções",
    "language": "Escolha a sua lingua"
  },
  "SUBSCRIPTION": {
    "subscriptionTitle": "A sua subscrição",
    "next_payment": "Próximo pagamento",
    "providers": "colaborador(es)",
    "discount": "Desconto",
    "total": "Total",
    "card": "Cartão",
    "direct_debit": "Débito Direto",
    "payment_method": "Método de Pagamento",
    "edit": "Editar subscrição",
    "invoices": "Ver faturas",
    "without_sms": "Sem SMS",
    "proPlan": "Plano Pro",
    "proPlusPlan": "Plano Pro+",
    "plansVAT": "IVA incluído à taxa em vigor"
  },
  "INVOICES": {
    "desc": "As suas faturas ficam disponíveis no início do dia seguinte",
    "invoice_data": "Dados de faturação",
    "company_name": "Nome (opcional)",
    "company_vat": "Número de identificação fiscal",
    "name": "Nome",
    "date": "Data",
    "value": "Valor",
    "emptyState": "Não existem faturas disponíveis"
  },
  "SIGNUP": {
    "testimonial": {
      "benefitsTitle": "Porquê usar o BUK?",
      "benefitsList": [
        "Gestão de Equipa e Clientes",
        "Lembretes SMS ilimitados",
        "Envio de campanhas E-mail e SMS",
        "Página de marcações personalizada",
        "Aumente as suas Google Reviews",
        "Aceite pagamentos MBWay"
      ],
      "quote": "\"O BUK é fácil de usar, super interativo, prático e funcional, permite trabalhar de uma forma mais organizada e profissional.\"",
      "author": "David Frazão — Bento Barbearias"
    }
  },
  "SETUP_GUIDE": {
    "create_account": "Criar conta",
    "configure_business": "Configure o seu negócio",
    "add_your_schedule": "Adicione o seu horário",
    "add_your_services": "Adicione os seus serviços",
    "create_first_appointment": "Crie a primeira marcação",
    "setup_booking_page": "Editar página de marcações",
    "import_clients": "Importe os seus clientes",
    "win_10_eur": "Ganhe 10€",
    "stepsLeft": "Restam apenas {{steps}} passos",
    "stepLeft": "Resta apenas {{steps}} passo",
    "extraReady": "Prepare-se ao máximo ⚡️",
    "almostReady": "Está quase pronto!",
    "noThankYou": "Não, obrigado!",
    "extraStepLeft": "Resta apenas {{steps}} passo extra ⚡️",
    "extraStepsLeft": "Restam apenas {{steps}} passos extra ⚡️",
    "titleSuccess": "Boa, chegou aos 100%! 🎉",
    "descSuccess": "Agora que já tem as configurações básicas, está na hora de personalizar a sua página de marcações.",
    "ctaSuccess": "Personalizar agora"
  },
  "NPS": {
    "question": "Numa escala de 0 a 10, quanto recomendaria o BUK a um amigo ou colega?",
    "subtitle": "0 - Pouco provavel / 10 - Muito provavel",
    "thanks": "Obrigado pelo seu feedback!",
    "btn1": "Fechar",
    "btn2": "Avaliar agora!",
    "inviteModalTitle": "Convidar amigos para o BUK",
    "inviteModalSubtitle": "Ofereça 50% de desconto aos seus amigos e ganhe 50€ em Marketing e 50€ de crédito na sua suscrição.",
    "reviewBukOnGoogle": "Avalie-nos no Google e ajude outras pessoas a encontrar-nos.",
    "inviteYourFriends": "Convide os seus amigos e ganhe 100€",
    "btnRef": "Convidar Amigos"
  },
  "CANCEL_XP": {
    "title": "Cancelar Subscrição",
    "warning": "Atenção, irá perder acesso à sua conta e aos dados dos seus clientes.",
    "warning_account": "Não poderá aceder à sua conta",
    "warning_clients": "Não poderá aceder aos dados dos seus clientes",
    "keep_access": "Para manter o acesso à sua conta, tem de mudar para o plano Grátis em 'Editar Subscrição'",
    "back": "Voltas atrás",
    "continue": "Continuar",
    "subtitle": "Escolha uma opção",
    "subtitle_improvements": "Ajude-nos a perceber como podemos melhorar o nosso serviço",
    "subtitle_competitors": "Qual o sistema que irá adoptar?",
    "subtitle_promo": "Queremos propor-lhe 3 meses com 50% de desconto. Estaria interessado?",
    "title_leaving": "Ficamos tristes de o ver partir...",
    "pricing_before": "ANTES",
    "pricing_now": "AGORA",
    "btn_accept": "Aceitar promoção",
    "btn_reject": "Não aceitar e cancelar",
    "changeSoftware": "Troquei de software",
    "closing": "O negócio vai fechar",
    "temporaryClose": "Vou fechar temporariamente",
    "personalReason": "Motivos pessoais",
    "notAdequate": "BUK não tem o que preciso",
    "other": "Outro",
    "price": "Melhor preço",
    "features": "Mais funcionalidades",
    "support": "Melhor suporte técnico",
    "performance": "Menos bugs",
    "noSoftware": "Nenhum"
  },
  "GOOGLE_PLACE": {
    "input": "Procurar por nome ou morada"
  },
  "CREATE_MERCHANT": {
    "googleQuestion": "O seu negócio está no Google?",
    "googleNotes": "Só usamos esta informação para preencher automaticamente dados como horários e serviços, poupando-lhe tempo na criação da conta.",
    "skipStep": "Saltar este passo",
    "confirm": "Confirmar"
  },
  "SALES_LIST_PAGE": {
    "sales": "Vendas",
    "payments": "Pagamentos",
    "commissions": "Comissões",
    "filterFieldPlaceholder": "Filtrar por Nome / NIF / Fatura",
    "allUsers": "Todos",
    "state": "Estado",
    "paid": "Pago",
    "cancelled": "Cancelado",
    "toPay": "Por pagar",
    "totalCommissions": "Comissões",
    "totalAmountWithoutCommissions": "Total s/ Comissões",
    "emptyState": {
      "title": "Sem vendas",
      "description": "Não existem vendas para mostrar."
    },
    "invoice": "Fatura",
    "salesCode": "Venda",
    "nameVat": "Nome / NIF",
    "registeredBy": "Registado por",
    "totalValue": "Valor total",
    "downloadAll": "Download todas faturas",
    "exportXLS": "Exportar (XLS)",
    "seeDetails": "Ver detalhes",
    "emailInvoice": "Enviar fatura",
    "downloadInvoice": "Download fatura",
    "paymentMethod": "Pagamento",
    "paymentsCount": "Pagamento(s)",
    "continueDraft": "Continuar rascunho",
    "deleteDraft": "Eliminar rascunho",
    "deleteDraftConfirm": "Tem a certeza que deseja eliminar este rascunho? Esta ação não pode ser anulada."
  },
  "INVOICING_SERVICE": {
    "dateRanges": {
      "today": "Hoje",
      "yesterday": "Ontem",
      "thisWeek": "Esta semana",
      "lastWeek": "Semana passada",
      "thisMonth": "Este mês",
      "lastMonth": "Último mês",
      "thisYear": "Este Ano",
      "firstQuarter": "1º Trimestre",
      "secondQuarter": "2º Trimestre",
      "thirdQuarter": "3º Trimestre",
      "fourthQuarter": "4º Trimestre",
      "untilNow": "Até agora",
      "custom": "Personalizado",
      "nextWeek": "Próxima semana",
      "nextMonth": "Próximo mês",
      "fromNow": "A partir de agora"
    }
  },
  "SALES_STATUS": {
    "paid": "Pago",
    "pending": "Por pagar",
    "cancelled": "Cancelado",
    "draft": "Rascunho",
    "uninvoiced": "Por faturar"
  },
  "DATE_RANGE_MODAL": {
    "title": "Escolha 2 datas",
    "dateInit": "Data de Início",
    "dateEnd": "Data de Fim",
    "filter": "Filtrar",
    "dateFormat": "dd/mm/aaaa"
  },
  "PAYMENTS_LIST_PAGE": {
    "emptyState": {
      "title": "Sem pagamentos",
      "description": "Não existem pagamentos para mostrar."
    },
    "invoice": "Fatura",
    "nameVat": "Nome / NIF",
    "registeredBy": "Registado por",
    "paymentMethod": "Método de pagamento",
    "value": "Valor",
    "bukPay": "Stripe",
    "salesCode": "Venda",
    "paymentsOnline": "Online"
  },
  "INVOICE_PAYMENT_METHOD": {
    "title": "Registar",
    "clientSection": "Dados para faturação",
    "vat": "NIF",
    "name": "Name",
    "cae": "CAE",
    "payLaterDescription": "Registar agora, mas receber o pagamento mais tarde",
    "partialPayDescription": "Registar e receber apenas parte do valor da venda",
    "fullPayDescription": "Registar e receber o valor total da venda",
    "payLaterTitle": "Será registada uma venda por liquidar",
    "payLaterList1": "Irá registar uma dívida no cliente selecionado",
    "payLaterList2": "Para saldar esta dívida mais tarde, pode consultado a ficha de cliente ou na secção de Vendas",
    "payNow": "Valor a pagar agora",
    "partialPaymentMissing": "Irá ficar registado por pagar",
    "paymentMethod": "Método de pagamento",
    "paymentMethodRequired": "Escolha pelo menos um método de pagamento",
    "valueByPaymentMethod": "Valor por método de pagamento",
    "value": "Valor",
    "paymentSumError": "A soma dos pagamentos deve ser igual ao total a pagar",
    "descriptionLabel": "Observações",
    "descriptionPlaceholder": "Escreva observações adicionais",
    "descriptionError": "Observações inválidas, máximo 200 caracteres",
    "doInvoice": "Faturar",
    "doSale": "Registar",
    "saveDraft": "Guardar rascunho",
    "resumeDraftTitle": "Retomar rascunho",
    "draftSavedBy": "guardado por {{name}} a {{date}}",
    "payment": "Pagamento",
    "card": "Cartão",
    "cash": "Dinheiro",
    "mbway": "MB Way",
    "mbref": "Multibanco",
    "transfer": "Transferência",
    "other": "Outro",
    "full": "Pagar tudo",
    "partial": "Pagar parcial",
    "later": "Pagar depois",
    "onlineApplePay": "Online (Apple Pay)",
    "onlineGooglePay": "Online (Google Pay)",
    "onlineCCard": "Online (Cartão de crédito)",
    "onlineMbway": "Online (MB Way)",
    "onlineMbref": "Online (Multibanco)",
    "teya": "Terminal Teya",
    "continueToTerminal": "Continuar para o Terminal"
  },
  "COMMISSIONS_LIST_PAGE": {
    "totalCommission": "Comissão Total",
    "emptyState": {
      "title": "Nenhuma comissão encontrada",
      "description": "Não há comissões para exibir no momento."
    },
    "sale": "Venda",
    "nameVat": "Cliente",
    "serviceProduct": "Serviço",
    "totalWithVat": "Total c/IVA",
    "commissionWithVat": "Comissão c/IVA"
  },
  "INVOICE_PREVIEW": {
    "creditNote": "Cancelar (NC)",
    "cancelSale": "Cancelar",
    "pay": "Pagar",
    "summary": "Resumo",
    "discount": "Desconto Global",
    "subTotal": "Subtotal",
    "totalVAT": "IVA",
    "sendPaymentLink": "Enviar link de pagamento",
    "editPayments": "Editar pagamentos",
    "emptyState": "Adicione um serviço ou produto para começar.",
    "seeDetails": "Ver detalhes",
    "bookingDate": "Marcação",
    "bookingOpenFailed": "Não foi possível abrir esta marcação. Pode ter sido apagada ou já não aparece no calendário.",
    "editSale": "Editar",
    "editingExistingSale": "Não é possível editar itens já registrados. Para corrigir algum erro, por favor cancele esta venda.",
    "invoiceRemaining": "Faturar restante",
    "doInvoice": "Faturar",
    "cancelOldInvoiceWarning": "Ao faturar, será emitida uma Nota de Crédito com o valor do sinal e uma nova fatura com o valor total.",
    "atLeastOneItemMustHavePrice": "Para uma venda ter total zero deve adicionar um valor e um desconto de 100%."
  },
  "INVOICING_PAGE": {
    "registerSale": "Registar venda",
    "registerPayment": "Registar pagamento"
  },
  "INVOICE_ADD_ITEMS": {
    "addPatientTitle": "Adicionar cliente",
    "addPatientDescription": "Escolha um cliente (opcional)",
    "title": "O que deseja registar?",
    "searchPlaceholder": "Filtrar por nome",
    "emptyServicesTitle": "Sem serviços",
    "emptyServicesDescription": "Sem serviços disponíveis para mostrar.",
    "emptyProductsTitle": "Sem produtos",
    "emptyProductsDescription": "Sem produtos disponíveis para mostrar.",
    "services": "Serviços",
    "products": "Produtos"
  },
  "PATIENT_SELECTOR": {
    "patientName": "Nome do cliente",
    "searchPlaceholder": "Procurar Nome, NIF, Telefone",
    "patientNotFound": "cliente não encontrado",
    "search": "Procurar",
    "createNewPatient": "Novo cliente"
  },
  "INVOICE_ITEM_EDIT_MODAL": {
    "title": "Editar",
    "quantity": "Qtd.",
    "unitPrice": "Preço",
    "discount": "Desconto",
    "vatRate": "IVA",
    "vatExemption": "Razão de isenção",
    "hasProviders": "Associar profissional",
    "provider": "Profissional",
    "commission": "Comissão",
    "addProvider": "Adicionar profissional"
  },
  "INVOICE_DISCOUNT_MODAL": {
    "discountPercentageInvalid": "Desconto inválido. Deve estar entre 0% e 100%.",
    "discountAmountCentsInvalid": "Valor do desconto inválido. Deve ser entre 0 e o total da fatura.",
    "title": "Desconto Global",
    "valueToPay": "Valor a pagar",
    "discount": "Desconto"
  },
  "SALE_DETAILS": {
    "headerTitle": "Venda",
    "registeredBy": "Registado por",
    "documents": "Documentos",
    "history": "Histórico",
    "missingPayment": "Por pagar",
    "canceled": "Cancelado",
    "summary": "Resumo",
    "partialInvoice": "Pré-pagamento",
    "tip": "Gorjeta"
  },
  "INVOICE_SUCCESS": {
    "success": "Registado com sucesso!",
    "conclude": "Concluir",
    "goToStart": "Ir para o início",
    "goToSales": "Ir para vendas",
    "openSaleDetails": "Ver detalhes da venda",
    "emailInvoice": "Enviar fatura por email",
    "printInvoice": "Imprimir fatura",
    "downloadInvoice": "Download fatura",
    "printTicket": "Imprimir talão",
    "moreOptions": "Mais opções",
    "goToPayments": "Ir para pagamentos",
    "invoiceFailedTitle": "Não foi possível gerar a fatura",
    "invoiceFailedDescription": "O registo de uma venda foi efectuado mas a fatura não foi emitida. Para emitir a fatura desta venda visite a página de Vendas.",
    "paymentFailedTitle": "O pagamento falhou",
    "paymentFailedDescription": "A venda foi registada, mas o pagamento não foi concluído. Pode tentar novamente."
  },
  "EDIT_COMMISSION_MODAL": {
    "title": "Editar comissão"
  },
  "CANCEL_INVOICE_MODAL": {
    "titleInvoice": "Emitir Nota de Crédito",
    "descriptionInvoice": "Atenção, esta ação não poderá ser revertida. Vai ser gerada uma nota de crédito com o valor total da fatura.",
    "title": "Cancelar venda",
    "description": "Atenção, esta ação não poderá ser revertida.",
    "reasonLabel": "Motivo",
    "reasonPlaceholder": "Escreva um motivo",
    "cancel": "Fechar",
    "paymentsWarning": "Tem de efectuar o reembolso pessoalmente.",
    "refundPaymentMethodLabel": "Método de pagamento da devolução",
    "refundPaymentMethodPlaceholder": "Selecione método de pagamento",
    "refundPaymentMethodRequired": "Selecione o método de pagamento da devolução"
  },
  "REPLACE_INVOICE_MODAL": {
    "title": "Cancelar e corrigir venda",
    "description": "Esta venda vai ser cancelada e o seu conteúdo será copiado para uma nova.",
    "descriptionInvoice": "Atenção: esta ação não poderá ser revertida.",
    "warningMessage": "Atenção: esta venda tem faturas associadas. Será emitida uma Nota de Crédito automaticamente.",
    "descriptionNoInvoice": "Esta ação não poderá ser revertida.",
    "back": "Voltar atrás",
    "cancelSale": "Cancelar venda",
    "cancelledSuccessfully": "Venda cancelada com sucesso!"
  },
  "INVOICING_SETTINGS": {
    "setupHeader": "Para aceder o módulo de faturação, precisamos apenas que nos envie alguns dados",
    "merchantName": "Nome de Registo",
    "vatNumber": "NIF da entidade",
    "address": "Morada",
    "city": "Localidade",
    "postalCode": "Código postal",
    "sendRequest": "Enviar pedido",
    "askForHelp": "Falar connosco",
    "autoridadeTributaria": "Software Certificado pela Autoridade Tributaria Nº2578.",
    "header": "Simplifique a sua faturação e poupe tempo na gestão do negócio",
    "description": "Emita faturas de forma automática e organizada, sem complicações. Tenha sempre o controlo das suas vendas e pagamentos num só lugar.",
    "configurations": "Configurações",
    "invoicingData": "Dados de faturação",
    "communicationWithAT": "Configurar comunicação com AT",
    "legalRequirement": "Para usar o sistema de faturação é obrigatório por lei ativar a comunicação com a AT.",
    "atPortal": "Portal das Finanças",
    "createAtUser": "Crie um novo utilizador no portal das finanças.",
    "addAtUser": "Adicionar Utilizador",
    "activateCommunication": "Ativar Comunicação",
    "addUserToBUK": "Adicione o novo utilizador ao BUK.",
    "atCredentials": "Credenciais",
    "atCredentialsUser": "Utilizador da AT",
    "atSectionTitle": "Autoridade Tributária",
    "atSectionDescription": "Configure o seu acesso e comunicação",
    "authenticate": "Autenticação",
    "saftTitle": "Ficheiros SAF-T",
    "downloadSaft": "Download SAF-T",
    "viewAtCommunications": "Ver comunicações com a AT",
    "atCommunications": "Comunicações com a AT",
    "communicationType": "Tipo",
    "communicationInfo": "Detalhe",
    "communicationResult": "Resultado",
    "communicationSuccess": "Sucesso",
    "communicationError": "Erro",
    "noAtCommunications": "Não existem comunicações",
    "atCommunicationTypeSaft": "SAF-T",
    "atCommunicationTypeGt": "Guia de Transporte",
    "previousPage": "Anterior",
    "nextPage": "Seguinte",
    "autoSendSaft": "Comunicar automaticamente para a AT (dia 2 de todos os meses)",
    "autoCommunication": "Comunicação automática",
    "autoCommunicationDay": "Dia 2 de todos os meses",
    "communicationsList": "Lista de comunicações",
    "communicationsListDescription": "Consulte as comunicações com a AT",
    "consultCommunications": "Consultar",
    "deactivate": "Desligar",
    "activate": "Activar",
    "logoRecommendedSize": "jpg, png (Tam. rec.: 384x128px)",
    "year": "Ano",
    "month": "Mês",
    "authoritySiteDescription1": "Aceda ao Portal das Finanças para criar um utilizador",
    "authoritySiteDescription2": "Nome de utilizador pode usar <b>“BUK”</b>",
    "authoritySiteDescription3": "Escolha uma password segura, e adicione as seguintes permissões: <b>WFA</b> (Comunicação de faturação), <b>WSE</b> (Comunicação de Séries).",
    "authoritySiteDescription4": "Clique <b>Submeter</b>",
    "openAuthoritySite": "Aceder ao Portal das Finanças",
    "closeAndContinue": "Fechar e continuar",
    "askForAccess": "Pedir acesso",
    "emailAddress": "Email"
  },
  "ACTIVATE_INVOICING_AUTHORITY": {
    "img": "Autoridade Tributária",
    "title": "Ativar comunicação",
    "titleReconfigure": "Atualizar credenciais AT",
    "description": "Preencha o utilizador e senha criados anteriormente no Portal das Finanças.",
    "descriptionReconfigure": "Introduza o utilizador e a senha do Portal das Finanças.",
    "userDescription": "No Portal das Finanças, o utilizador tem o formato {{vatNumber}}/número (ex: {{vatNumber}}/1). Introduza abaixo apenas o número atribuído ao novo utilizador.",
    "userLabel": "Utilizador",
    "userPlaceholder": "Ex: 1",
    "userInvalid": "Introduza o número do utilizador atribuído no Portal das Finanças.",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Introduza a senha",
    "newAccountWarning": "Se acabou de criar este utilizador no Portal das Finanças, pode demorar alguns minutos até ficar disponível para ativação. Se o pedido falhar ou expirar, tente novamente daqui a cerca de 5 minutos.",
    "send": "Activar Comunicação"
  },
  "UPLOAD_INVOICING_LOGO": {
    "title": "Logotipo",
    "fileType": "jpg, png (min. 640x640px)",
    "upload": "Upload",
    "reset": "Remover"
  },
  "EMAIL_INVOICE_MODAL": {
    "successTitle": "Enviado",
    "successMessage": "Documentos enviados com sucesso.",
    "title": "Confirmar email",
    "emailLabel": "Email",
    "emailPlaceholder": "Email para onde enviar a fatura",
    "send": "Enviar agora"
  },
  "CLIENT_SALES": {
    "emptyState": {
      "title": "Sem vendas",
      "description": "Não existem vendas para mostrar."
    }
  },
  "REPORTS_LIST": {
    "title": "Relatórios",
    "generalReport": "Relatório Geral",
    "generalReportDesc": "Resumo das principais métricas do seu negócio",
    "explore": "Explorar",
    "sectionSales": "Vendas",
    "sectionCommissions": "Comissões",
    "sectionPayments": "Pagamentos",
    "sectionBookings": "Marcações",
    "sectionClients": "Clientes",
    "sectionCommunication": "Comunicação"
  },
  "CALENDAR_TOOLTIP_TEMPLATE": {
    "reason": "Motivo",
    "provider": "Profissional",
    "schedule": "Horário",
    "patient": "Cliente",
    "service": "Serviço",
    "roomEquipment": "Sala/Equipamento",
    "roomOccupied": "Ocupado",
    "notes": "Observações",
    "noShow": "Faltou",
    "confirmed": "Confirmado",
    "arrived": "Chegou",
    "cancelled": "Cancelada",
    "prepaymentInvoice": "Fatura de pré-pagamento",
    "invoice": "Fatura",
    "sale": "Venda"
  },
  "REPORTS_SERVICE": {
    "salesSummaryTitle": "Items Vendidos",
    "salesSummaryDescription": "Vendas agrupadas por serviço ou produto",
    "salesTotalsTitle": "Totais de Vendas",
    "salesTotalsDescription": "Métricas Totais das suas Vendas",
    "salesMonthlyTitle": "Vendas mensais",
    "salesMonthlyDescription": "Vendas agrupadas por mês com totais de faturação e pagamentos.",
    "taxesSummaryTitle": "Resumo de IVA",
    "taxesSummaryDescription": "Resumo de todas as transações relacionadas com IVA.",
    "vatRatesFilterLabel": "Taxa de IVA",
    "vatRatesFilterPlaceholder": "Selecione as taxas de IVA",
    "saleStatusFilterLabel": "Estado da Venda",
    "saleStatusFilterPlaceholder": "Selecione o estado da venda",
    "invoiceStatusFilterLabel": "Estado da Fatura",
    "invoiceStatusFilterPlaceholder": "Selecione o estado da fatura",
    "createdByUserFilterLabel": "Criado por utilizador",
    "createdByUserFilterPlaceholder": "Selecione o utilizador que criou",
    "providerFilterLabel": "Profissional",
    "providerFilterPlaceholder": "Selecione o profissional",
    "providersFilterLabel": "Profissionais",
    "providersFilterPlaceholder": "Selecione os profissionais",
    "saleItemTypeFilterLabel": "Tipo de Item da Venda",
    "saleItemTypeFilterPlaceholder": "Selecione o tipo de item da venda",
    "salesListTitle": "Lista de vendas",
    "salesListDescription": "Listagem completa de todas as transações de venda individuais.",
    "paymentsListTitle": "Lista de pagamentos",
    "paymentsListDescription": "Listagem completa de todos os pagamentos individuais.",
    "paymentsSummaryTitle": "Totais por método de pagamento",
    "paymentsSummaryDescription": "Totais de pagamentos agrupados por método de pagamento.",
    "onlinePaymentsListTitle": "Lista de pagamentos online",
    "onlinePaymentsListDescription": "Pagamentos online efectuados no acto da marcação.",
    "upfrontPaymentsSummaryTitle": "Pagamentos online por mês",
    "upfrontPaymentsSummaryDescription": "Análise de pagamentos e sinais recebidos ao longo do tempo.",
    "tipsMonthlyTitle": "Gorjetas Teya por mês",
    "tipsMonthlyDescription": "Total de gorjetas recebidas via terminal Teya, agrupadas por mês.",
    "commissionsListTitle": "Lista de comissões",
    "commissionsListDescription": "Listagem completa de todas as transações de comissão individuais.",
    "commissionsSummaryTitle": "Resumo de comissões",
    "commissionsSummaryDescription": "Visão geral das comissões ganhas por profissional, localização e itens de venda.",
    "paymentMethodFilterLabel": "Método de pagamento",
    "paymentMethodFilterPlaceholder": "Selecione o método de pagamento",
    "bookingsListTitle": "Lista de marcações",
    "bookingsListDescription": "Listagem completa de todas as marcações agendadas.",
    "bookingsSummaryTitle": "Resumo de marcações",
    "bookingsSummaryDescription": "Visão geral de tendências, cancelamentos e faltas.",
    "cancellationsNoshowSummaryTitle": "Cancelamentos e faltas por mês",
    "cancellationsNoshowSummaryDescription": "Análise de cancelamentos e faltas para identificar padrões.",
    "workingHoursSummaryTitle": "Resumo de horas de trabalho",
    "workingHoursSummaryDescription": "Visão geral das horas operacionais e produtividade da equipa.",
    "incidentTypeFilterLabel": "Tipo",
    "incidentTypeFilterPlaceholder": "Selecione o tipo",
    "incidentTypeBoth": "Cancelamentos e faltas",
    "incidentTypeCancellations": "Cancelamentos",
    "incidentTypeNoshows": "Faltas",
    "cancelledByFilterLabel": "Cancelado por",
    "cancelledByFilterPlaceholder": "Selecione quem cancelou",
    "cancelledByAll": "Todos",
    "cancelledByClient": "Cliente",
    "cancelledByBusiness": "Negócio",
    "periodTypeFilterLabel": "Período",
    "periodTypeFilterPlaceholder": "Selecione o agrupamento",
    "periodTypeDay": "Dia",
    "periodTypeWeek": "Semana",
    "periodTypeMonth": "Mês",
    "bookingsByProviderTitle": "Marcações por profissional",
    "bookingsByProviderDescription": "Número de marcações agrupadas por profissional.",
    "bookingsByProviderServiceTitle": "Marcações por profissional e serviço",
    "bookingsByProviderServiceDescription": "Número de marcações agrupadas por profissional e serviço.",
    "clientsListTitle": "Listagem de clientes",
    "clientsListDescription": "Lista de clientes com estatísticas de marcações e cancelamentos.",
    "clientsSummaryTitle": "Resumo de clientes",
    "clientsSummaryDescription": "Visão geral da base de clientes, aquisição e retenção.",
    "clientTypeFilterLabel": "Tipo de cliente",
    "clientTypeFilterPlaceholder": "Selecione o tipo de cliente",
    "clientTypeAll": "Todos",
    "clientTypeNew": "Novos",
    "clientTypeReturning": "Recorrentes",
    "clientsBirthdaysTitle": "Aniversários",
    "clientsBirthdaysDescription": "Clientes com aniversário no período selecionado.",
    "smsListTitle": "SMS enviados",
    "smsListDescription": "Listagem de SMS enviados com estado de entrega.",
    "bookingStatusFilterLabel": "Estado",
    "bookingStatusFilterPlaceholder": "Selecione os estados das marcações",
    "bookingStatusScheduled": "Agendada",
    "bookingStatusCompleted": "Concluída",
    "servicesFilterLabel": "Serviços",
    "servicesFilterPlaceholder": "Selecione os serviços",
    "categoriesFilterLabel": "Categorias",
    "categoriesFilterPlaceholder": "Selecione as categorias"
  },
  "SALE_ITEM_TYPE": {
    "all": "Todos",
    "service": "Serviço",
    "product": "Produto",
    "other": "Outro"
  },
  "INVOICE_STATUS": {
    "invoiced": "Faturado",
    "uninvoiced": "Por faturar",
    "partiallyInvoiced": "Parcialmente faturado"
  },
  "REPORT_PAGE": {
    "emptyState": {
      "title": "Sem dados",
      "description": "Não existem dados para mostrar."
    },
    "filterFieldPlaceholder": "Procurar...",
    "downloadCsvError": "Não foi possível gerar o ficheiro CSV. Por favor tente novamente mais tarde.",
    "downloadCsv": "Download"
  },
  "REPORTS_TABLE": {
    "saleItem": "Item",
    "category": "Categoria",
    "itemType": "Tipo de Item",
    "quantity": "Quantidade",
    "grossSales": "Valor Bruto",
    "discounts": "Descontos (c/IVA)",
    "netSales": "Subtotal",
    "tax": "IVA",
    "total": "Total (c/IVA)",
    "totalColumnTitle": "Métrica",
    "totalColumnValue": "Valor",
    "saleReference": "Venda",
    "clientName": "Nome",
    "clientNamePhone": "Nome / telemóvel",
    "createdByUserName": "Registado por",
    "createdAt": "Data",
    "saleDate": "Data",
    "monthStart": "Mês",
    "salesCount": "N.º vendas",
    "paidAmountCents": "Valor pago",
    "pendingCents": "Valor pendente",
    "subtotalCents": "Subtotal (s/ IVA)",
    "vatCents": "IVA",
    "taxName": "Imposto",
    "taxRate": "Taxa",
    "taxableAmountCents": "Base tributável",
    "taxCollectedCents": "Imposto liquidado",
    "totalWithTaxCents": "Total c/ imposto",
    "transactionCount": "N.º vendas",
    "periodLabel": "Mês",
    "paymentsCollectedCount": "Pagamentos recebidos",
    "amountCollectedCents": "Valor recebido",
    "totalCancelled": "Total canc.",
    "cancellationRatePercent": "Taxa de canc.",
    "cancelledByClient": "Canc. p/ cliente",
    "cancelledByBusiness": "Canc. p/ negócio",
    "totalNoShows": "Total faltas",
    "noshowRatePercent": "Taxa de faltas",
    "lostRevenueCents": "Receita perdida",
    "mostCancelledService": "Serviço mais cancelado",
    "mostNoShowClient": "Cliente com mais faltas",
    "totalCents": "Valor total",
    "saleStatusLabel": "Estado",
    "paymentMethod": "Método de pagamento",
    "paymentCount": "N.º pagamentos",
    "tipCount": "N.º gorjetas",
    "tipCents": "Gorjetas",
    "amountCents": "Valor",
    "paidAt": "Data pagamento",
    "totalAmountPaidCents": "Valor total pago",
    "priceToMerchant": "Valor para si",
    "priceToBuk": "Comissão BUK",
    "clientEmail": "Email",
    "clientPhone": "Telemóvel",
    "providerName": "Profissional",
    "totalSalesCents": "Total vendas",
    "totalCommissionsCents": "Total comissões",
    "commissionRateAvgPercent": "Taxa comissão",
    "servicesCommissionCents": "Comissão serviços",
    "productsCommissionCents": "Comissão produtos",
    "availableHours": "Horas disponíveis",
    "bookedHours": "Horas marcadas",
    "unbookedHours": "Horas livres",
    "utilizationRatePercent": "Taxa de utilização",
    "revenuePerHourCents": "Receita por hora",
    "serviceName": "Serviço / Produto",
    "serviceTotalCents": "Total (c/ IVA)",
    "commissionAmountCents": "Comissão (c/ IVA)",
    "dateInit": "Data e hora",
    "durationMinutes": "Duração (min)",
    "bookingStatusLabel": "Estado",
    "bookingSourceLabel": "Origem da marcação",
    "priceCents": "Preço",
    "notes": "Notas",
    "firstName": "Nome",
    "lastName": "Apelido",
    "dob": "Aniversário",
    "email": "Email",
    "phoneNumber": "Telemóvel",
    "campaignsEmailSms": "Campanhas e-mail e SMS",
    "bookingsCount": "Marcações",
    "cancellationsCount": "Cancelamentos",
    "totalBookingsValueCents": "Valor total marcações",
    "templateLabel": "Tipo de SMS",
    "bookingDateInit": "Data da marcação",
    "messageParts": "Partes SMS",
    "smsProviderLabel": "Operador",
    "deliveryStatusLabel": "Estado de entrega"
  }
}
